import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import * as saveAs from 'file-saver';
import { SignaturePad } from 'angular2-signaturepad';
import { Observable, ReplaySubject, Subject, ignoreElements } from 'rxjs';
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import Swal from 'sweetalert2';
import { HttpClient } from '@angular/common/http';
import { Config } from 'datatables.net';
import { DataTableDirective } from 'angular-datatables';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import * as moment from 'moment';
import { adjustWith2DecimalsForUI, getFooterTextForEmail, getServiceType, mailSuggestedTextForProviders } from 'src/app/common-functions';
import { LoaderService } from 'src/app/loader.service';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-adjudication-queue',
  templateUrl: './adjudication-queue.component.html',
  styleUrls: ['./adjudication-queue.component.css'],
  providers: [DecimalPipe],
})
export class AdjudicationQueueComponent implements OnInit {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  accessToken: string;
  adjudicationQueues: any;
  dtOptions: Config = {
    pagingType: 'simple_numbers',
    language: {
      searchPlaceholder: 'Search here...',
    },
    destroy: true,
  };
  public CORP_PAYROLL_NOT_MANDATORY_PACKAGES: any = [2, 8, 9];
  public CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS: any = [19, 20, 21, 23, 25, 26];
  dtTrigger: Subject<any> = new Subject<any>();
  requestQueueData: any;
  respondReason:any;
  dependentDetails: any;
  showChildForm:any =false;
  spouseDetails: any;
  isSpouse: any = false;
  isDependent: any = false;
  plansSummaryObj: any;
  notificationHistory: any;
  effectiveDateValue: any;
  effectiveDate: string = '';
  reason: string = '';
  provision: string = '';
  adminStatus: string;
  toEmail: string = '';
  subject: string = '';
  body: string = '';
  ccList: string = '';
  reminderStatus: string = 'Pending'; // Default status
  snoozeTime: string = '';
  reminderTime: string = '';
  reminderText: string = '';
  reasonList: any;
  spouseDob: Date = new Date();
  minDateHire: any;
  minDatechild: any;
  maxDatechild: any;
  genders: string[] = ['Male', 'Female'];
  planEffectiveDate: string;
  roeFile: any;
  dependentChildCoverage: any;
  childIndex: any;
  dependentCoverage:any = 'close';
  userEmail: any;
  fileName: any;
  invalidReason: boolean = false;
  planEnrollmentDates: any;
  childCoverage: any;
  coverageChange: any;
  showPlanDetails: boolean = false;
  customerPlans: any;
  selectedPlans_: any[];
  oldExistingPlans: any[];
  selectedTrues: any[];
  unSelectedPlans_: any[];
  totalSummaryPrice: number;
  upgradeorDowngradeplans: any= [];
  upgradeorDowngradeplansSelected: any = [];
  specialpackages: any = [];
  mainarray: any[];
  mainarrayValues: any[];
  mainarrayFinal: any[];
  modifiedBlocksPaidByCompany: string;
  modifiedBlocksCoveredByCompany: string;
  effectiveEmployeeTotalContibution: number;
  addbenificaryData: any[];
  allFormData: {};
  formData: {};
  companypaidproductid: any[];
  disabledcompanypaidproductid: any[];
  removedisabledcompanypaidproductid: any[];
  adddisabledcompanypaidproductid: any[];
  packagesInBlocks: any;
  basepackages: any;
  customerSelectedPlans: any;
  planAmount: any;
  deltaCompanyTax: any;
  displayPackage: any;
  unselected: any = [];
  finalEffectiveDate: any;
  productobj: any;
  planssummarymain: any;
  cartcheckvalue: boolean;
  planssummaryopt: any[];
  hoverStates: {
    [index: number]: boolean
  } = {};
  disabledelement: any;
  plansskumain: any = [];
  queue: any;
  childCovered: any;
  constructor(
    public elementRef: ElementRef,
    public _decimalPipe: DecimalPipe,
     private renderer: Renderer2,
    private http: HttpClient, private router: Router, private formBuilder: FormBuilder,public _LoaderService: LoaderService,
  ) { }

  ngOnInit(): void {


    this.minDateHire = moment().subtract(60, "years").calendar();

    this.planEnrollmentDates = [
          moment().subtract(1, 'months').startOf('month').format('MMM-DD-YYYY'), // Previous month
      moment().startOf('month').format('MMM-DD-YYYY'),
          moment().add(1, 'months').startOf('month').format('MMM-DD-YYYY'),
          moment().add(2, 'months').startOf('month').format('MMM-DD-YYYY'),
          moment().add(3, 'months').startOf('month').format('MMM-DD-YYYY'),

        ]

    this.minDatechild = new Date(this.minDateHire);
    this.maxDatechild = new Date();

    this.spouseform = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(1)]],
      lastName: ['', [Validators.required, Validators.minLength(1)]],
      dob: ['', [Validators.required, this.ageValidator(18)]],
      email: ['', [Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]],
      coveredByAnotherPlan: ['', [Validators.required]],
      healthPlan: ['', [Validators.required]],
      insurer: ['', [Validators.required]],
      gender: ['', [Validators.required]],
    });

    this.pureDependentform = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      lastName: ['', [Validators.required, Validators.minLength(2)]],
      // gender: ['', [Validators.required]],
      dob: ['', [Validators.required]],
      age: [''],
      phoneNum: [''],
      coveredByAnotherPlan: ['', [Validators.required]],
      graduationDate: [''],
      carrierName: ['', [Validators.required]],
      specialNeeds: [''],
      postSecondaryStudent: [''],
    });

    this.accessToken = sessionStorage.getItem('accessToken');
    this.getAdjudicationQueues()
  }

  get spouseForm() {
    return this.spouseform.controls;
  }

  get dependentPureForm() {
    return this.pureDependentform.controls;
  }




  public ageValidator(minAge: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const dob = control.value;
      if (!dob) {
        return null; // No DOB provided
      }

      const today = new Date();
      const birthDate = new Date(dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age < minAge ? { 'ageError': true } : null; // Return an error if under 18
    };
  }

  getAdjudicationQueues() {

    let endPoint = '/get-adjudication-queues'

    this.http.get(environment.apiUrl + '/api/ap' + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe(async (response: any) => {
      if (response.statusCode == 200) {

        this.adjudicationQueues = response.data.queues;
        this.adjudicationQueues.forEach(elem => {
          console.log(typeof elem.inputData); // Should log 'string' if it's a JSON string

          try {
            let inpData = JSON.parse(elem.inputData); // Properly parse JSON string
            console.log(typeof inpData); // Should log 'object'
            elem['data'] = inpData;
          } catch (e) {
            console.error('Failed to parse inputData:', elem.inputData, e);
            elem['data'] = null;
          }
        });

        console.log(this.adjudicationQueues);

        this.dtTrigger.next(null);
        // $('#DataTables_Table_1').dataTable().fnDestroy();
        // Swal.fire({ allowOutsideClick: false, title: "Info", text: response.message });

      } else {
        Swal.fire({ allowOutsideClick: false, title: "Error", text: response.message });
      }
    },
      (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: "Info",
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: "Proceed",
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: "Error", text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      })
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();


  }
  handleProcessDate(date: any) {
    return moment(date).format('YYYY-MM-DD')
  }


  onStatusChange() {
    let endPoint1:any ;
    if(!this.queue.data.isCorporateCustomer){
      endPoint1 = `/${this.queue.customerId}/customerPlans/${this.queue.data.event == 'children' ? 'dependent' : this.queue.data.event}/add`
    }else{
      endPoint1 = `/v2/${this.queue.customerId}/customerPlans/${this.queue.data.event == 'children' ? 'dependent' : this.queue.data.event}/add`
    }
    let enrollmentDate:any;
    if(this.dependentDetails && this.dependentDetails.length > 0) {
      enrollmentDate = this.dependentDetails[0]
    }
    this.finalEffectiveDate = this.queue.data.effectiveDate;
    let payload = {
      enrollmentDate: this.queue.data.effectiveDate,
      spouseCovered: this.spouseDetails.coveredByAnotherPlan == 'open' ? true : false,
      removeRoleBasedPlans: false,
      childCovered: this.childCovered,
      totalCount: this.dependentDetails.length - 1,
      totalCountIncluded: this.dependentDetails.length,
      isIncluded: this.queue.data.isPolicyChange
    }
    
    if(this.queue.data.isCorporateCustomer && this.queue.data.event == 'children'){
      payload.totalCount = this.dependentDetails.length;
      payload.totalCountIncluded =  this.dependentDetails.length;
    }
     if(this.queue.data.isPolicyChange){
    this.http.post(environment.url + endPoint1, payload, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.handleContinue(response, this.queue)
        console.log(response?.data, 'asda')
        this.coverageChange = response?.data?.coverageChange;
        let prs = response?.data?.gsOrEqMemberStatus ?? {}
        let prsStatus: any = []
        const prsKeys = Object.keys(prs);
        if (prsKeys.length > 0) {
          for (const prk of prsKeys) {
            if (prs[prk] == true) {
              if (prk == 'greenShildCustomer') {
                prsStatus.push('GreenShield')
              }
              if (prk == 'hcdSecuremePlans') {
                prsStatus.push('HCD Secureme')
              }
              if (prk == 'equitableCustomer') {
                prsStatus.push('Equitable')
              }
              if (prk == 'phrCustomer') {
                prsStatus.push('PHR')
              }
              if (prk == 'waddelCustomer') {
                prsStatus.push('Waddel')
              }
            }
          }
        }

        console.log("calledoooo")
        let data__ = response?.data?.packages;


        let ecDate = this.queue.data.effectiveDate
        const startOfCurrentMonth = moment(ecDate).startOf('month');
        const formattedDate = startOfCurrentMonth.format('MMMM Do'); // Format for "April 1st"

        // this.firstConfirmMessage = `Your marital status was changed to ${this.maritalStatusText(this.coverageChange)}`
       
        // if(this.normalDependentRegistration && this.normalSpouseRegistration){
        //    this.secondConfirmMessage = `Your policies have been ${this.enactMode == 'add' ? "upgraded" : "downgraded"} ${this.coveragetext(this.coverageChange)} effective ${formattedDate} ${moment().year()}`
        // }else{
        //   this.secondConfirmMessage = `Your reporting of life event change is outside the 30 day window. Coverage for your dependents has to be approved by the carrier(s) pending underwriting, which may take up to 6 weeks.`
        //   // this.secondConfirmMessage = `Your policies ${eventType == 'add' ? "upgrade" : "downgrade"} from ${this.coveragetext(this.coverageChange)} is pending approval from underwriting`
        //   // this.underWritingMessage1 = 'This can take upto 6 weeks to complete'
        //   this.underWritingMessage2 = "Once approved you'll be advised of the premium change"
        // }


      }
      else {
        Swal.fire({allowOutsideClick: false,title: 'Info', text:response.message})
      }
    }, (error) => {
      // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text: error.error.error.message})
    });
  }
  }

  saveChanges() {
    console.log('Effective Date:', this.planEffectiveDate);
    console.log('Reason:', this.reason);
    console.log(this.adminStatus);
    console.log(this.isSpouse)
    if(this.reason == ''){
      this.invalidReason = true;
    }else{
      this.invalidReason = false;
    }
    // if(this.isSpouse){
    //   console.log(this.spouseform.value.coveredByAnotherPlan)
    //    if (this.dependentCoverage == 'close') {
    //           this.spouseform.get('healthPlan')?.setValidators([]);
    //           this.spouseform.get('insurer')?.setValidators([]);
    //     } else {
    //       this.spouseform.get('healthPlan')?.setValidators([Validators.required]);
    //       this.spouseform.get('insurer')?.setValidators([Validators.required]);
    //     }
  
    //     // Ensure the form control's validity is re-evaluated after setting validators
    //     this.spouseform.get('healthPlan')?.updateValueAndValidity();
    //     this.spouseform.get('insurer')?.updateValueAndValidity();
    //   console.log("called", this.spouseform)
    //   if (this.spouseform.invalid) {
    //     this.spouseform.markAllAsTouched();

    //     // Loop through controls and print invalid ones
    //     for (const controlName in this.spouseform.controls) {
    //       if (this.spouseform.controls.hasOwnProperty(controlName)) {
    //         const control = this.spouseform.controls[controlName];
    //         if (control.invalid) {
    //           console.log(`Control ${controlName} is invalid`);
    //         }
    //       }
    //     }
    //     return;
    //   }
    // }

    

    const planDate = moment(this.planEffectiveDate, 'MMM DD YYYY');
    const tomorrow = moment().startOf('day').add(1, 'days');
    const isFutureFromTomorrow = planDate.isSameOrAfter(tomorrow);

    if(this.adminStatus == "" || this.adminStatus  == null || this.adminStatus == undefined){
      Swal.fire({title: "Info", text: "Please select status."}).then(res => {
        if(res.isConfirmed){
          return;
        }
      })
 
      return;
    }

    let endPoint:any;
    if(this.requestQueueData.methodName == "lifeChangeEvent") {
      endPoint =  `/underwriting-lec/${this.requestQueueData.id}/${this.requestQueueData.customerId}/lifeChange/${this?.requestQueueData?.data?.event ?? "spouse"}/${this?.requestQueueData?.data?.eventType2 ?? "add"}/false`
    }
    console.log(this.planEffectiveDate)
    console.log(endPoint)
     let plansMain = sessionStorage.getItem("plansummarymain") ? JSON.parse(sessionStorage.getItem("plansummarymain") || '') : []
    let plans:any = []
    if(this.queue.data.isCorporateCustomer){
      
      let plansummaryLIFEFinal:any = []
      let plansummary:any;
      let provisioning:any = false;
      let iafgPlansAvailability:any = false;
      let plansummaryMain:any = JSON.parse(sessionStorage.getItem("allSelectedPlans") || '')
      // this.plansummaryMain = JSON.parse(sessionStorage.getItem("plansummarymain")||'')

      let plansummaryLIFE:any = JSON.parse(sessionStorage.getItem("planssummarymainLife") || '')
      let planDetailsArrayBlock = JSON.parse(sessionStorage.getItem("planssummarymainLife") || '[]')



      plansummaryLIFE.forEach((element: any, index: number) => {

        element.member.maximumCoverageWithoutEvidence = element.member.defaultRange

        if (element.spouse && element.spouse.maximumCoverageWithoutEvidence) {
          element.spouse.maximumCoverageWithoutEvidence = element.spouse.defaultRange

        }
        element['amount'] = element.guaranteedAcceptanceDetails.amount
        element['amountUI'] = "$" + element.guaranteedAcceptanceDetails.amount
        element['planPrice'] = element.guaranteedAcceptanceDetails.amount
        element['total'] = element.guaranteedAcceptanceDetails.total
        element['totalPrice'] = element.guaranteedAcceptanceDetails.total
        element['skuTotalPrice'] = element.guaranteedAcceptanceDetails.total
        element['totalUI'] = "$" + element.guaranteedAcceptanceDetails.total
        element['tax'] = element.guaranteedAcceptanceDetails.tax
        element['taxUI'] = "$" + element.guaranteedAcceptanceDetails.tax
        plansummaryLIFEFinal.push(element)

      });
      planDetailsArrayBlock.forEach((element: any, index: number) => {
        if (element.id == 13) {
          iafgPlansAvailability = true
        }
        else {
          iafgPlansAvailability = false
        }

      });

      plansummary = plansummaryMain.concat(plansummaryLIFEFinal)

      // this.plansummary =this.plansummaryMain.concat(this.plansummaryLIFE)
      // this.optplansummary = JSON.parse(sessionStorage.getItem("allSelectedOptPlans"))
      plansummary = plansummary.sort(function (a: any, b: any) {
        return (a.packageId - b.packageId);
      })
      console.log(plansummary)
      let taxesInfo = {}
      plansummary.forEach((element: any) => {

        if (element.packageId == 1) {
          provisioning = true
        }

        element.totalPrice = this._decimalPipe.transform(element.totalPrice, "1.2-2")?.replace(/,/g, "")
        element.total = this._decimalPipe.transform(element.totalPrice, "1.2-2")?.replace(/,/g, "")
        element.tax = this._decimalPipe.transform(element.tax, "1.2-2")?.replace(/,/g, "")
        element.amount = this._decimalPipe.transform(element.amount, "1.2-2")?.replace(/,/g, "")
        element.planLevelName = element.groupName
        taxesInfo = this.determineTaxes(element?.products?.[0]?.calculatedTax?.planProductInfos ?? [])
        element.taxApplicable = element.tax > 0
        Object.assign(element, taxesInfo);
        plans.push(element)
      });
    }
      let inputD = this.requestQueueData.data;
      let inputData = {
        ...inputD,
        'adminReason': this.reason,
        'adminStatus': this.adminStatus,
        "mailContent": this.respondReason,
        "primaryEmail": this.userEmail,
        "effectiveDate": moment(this.planEffectiveDate).format("YYYY-MM-DD")
      }


      if(this.isSpouse){

         let spouseDetails = this.spouseform.value;

       const updatedSpouse = {
        ...spouseDetails,
        dob: moment(spouseDetails.dob, 'MM-DD-YYYY').format('YYYY-MM-DD')
      };
        inputData['spouseDetails'] = updatedSpouse

        inputData['childrenDetails'] = []
      }else{
        let updatedChildren = this.dependentDetails.map(child => ({
          ...child,
          gender: 'Undisclosed' // add new property
        }));
        // updatedChildren = updatedChildren.filter(item => item.isBackdated);
        inputData['childrenDetails'] = updatedChildren
        inputData['spouseDetails'] = {}
      }

    if(isFutureFromTomorrow){
      // means we need to add in the provisioning queue
      inputData['isFutureDated'] = true;
    }
    if(!isFutureFromTomorrow){
      // means we need to register
      inputData['isFutureDated'] = false;
    }

    let dataaaa:any;

    inputData['plans'] = this.queue.data.isCorporateCustomer ? plans : plansMain
    
    if(true){
      console.log('Sending email with payload:', inputData);

      this.http.post(environment.apiUrl + '/api/ap'+ endPoint, inputData, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.statusCode == 200) {
          console.log("mail sent");
          Swal.fire({ allowOutsideClick: false, title: "Info", text: "Request has been resolved successfully" }).then(res => {
            if(res.isConfirmed){
              window.location.reload()
            }
          })
        } else {
          Swal.fire({ allowOutsideClick: false, title: "Error", text: response.message });
        }
      },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: "Info",
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: "Proceed",
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: "Error", text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        })
    }else{
  
      // Call your email service or API here
  
      // call the api
      this.http.post(environment.apiUrl + '/api/ap'+ endPoint, inputData, {
        headers: {
          Authorization: 'Bearer ' + this.accessToken,
          'Content-Type': 'application/json',
        }
      }).subscribe((response: any) => {
        if (response.statusCode == 200) {
          console.log("mail sent");
          Swal.fire({ allowOutsideClick: false, title: "Info", text: "Request has been resolved successfully" }).then(res => {
            if(res.isConfirmed){
              window.location.reload()
            }
          })
        } else {
          Swal.fire({ allowOutsideClick: false, title: "Error", text: response.message });
        }
      },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: "Info",
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: "Proceed",
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: "Error", text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        })

      
    }

    console.log(inputData)
    
    // this.http.post(environment.apiUrl + endPoint, inputData, {
    //   headers: {
    //     Authorization: 'Bearer ' + this.accessToken,
    //     'Content-Type': 'application/json',
    //   }
    // }).subscribe((response: any) => {
    //   if (response.statusCode == 200) {
        
        

    //   } else {
    //     Swal.fire({ allowOutsideClick: false, title: "Error", text: response.message });
    //   }
    // },
    //   (error) => {
    //     if (
    //       error.status == 400 ||
    //       error.status == 401 ||
    //       error.status == 402 ||
    //       error.status == 403
    //     ) {
    //       Swal.fire({
    //         title: "Info",
    //         text: error.error.error.message,
    //         showDenyButton: false,
    //         showCancelButton: false,
    //         confirmButtonText: "Proceed",
    //       }).then((result) => {
    //         /* Read more about isConfirmed, isDenied below */
    //         if (result.isConfirmed) {
    //           sessionStorage.clear();
    //           this.router.navigate(['/login']);
    //         }
    //         else {
    //           sessionStorage.clear();
    //           this.router.navigate(['/login']);
    //         }
    //       });
    //     } else {
    //       // Swal.fire(error.error.error.message)
    //       Swal.fire({ title: "Error", text: error.error.error.message });
    //     }
    //     // this.toastrService.error("Invalid Credentials", 'Error!');
    //   })

  }


    public determineTaxes(taxArray:any) {
    let taxObj: any = {
      pst: null,
      pstTaxRate: null,
      hst: null,
      hstTaxRate: null,
      gst: null,
      gstTaxRate: null,
      taxName: null,
      taxPrice: null
    };
    for (let tax of taxArray) {
      if (!taxObj.taxName || taxObj.taxName == null) {
        taxObj.taxName = "";
      }
 
      if (tax.name.includes("PST") || tax.name.includes("Prov")) {
        taxObj.pst = tax.price + (taxObj.pst ?? 0);
        taxObj.pstTaxRate = (tax.taxRate) * 100
           if(!taxObj.taxName.includes(tax.name))
        taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("HST")) {
        taxObj.hst = tax.price + (taxObj.hst ?? 0);
        taxObj.hstTaxRate = (tax.taxRate) * 100
           if(!taxObj.taxName.includes(tax.name))
        taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("GST")) {
        taxObj.gst = tax.price + (taxObj.gst ?? 0);
        taxObj.gstTaxRate = (tax.taxRate) * 100;
          if(!taxObj.taxName.includes(tax.name))
        taxObj.taxName += tax.name + " | "
      }
    }
    taxObj.taxName = taxObj.taxName?.trim();
    if (taxObj.taxName && taxObj.taxName[taxObj.taxName.length - 1] == "|") {
      taxObj.taxName = taxObj.taxName.slice(0,-1);
      taxObj.taxName = taxObj.taxName?.trim();
    }
 
    if (taxObj.pst || taxObj.hst || taxObj.gst) {
      taxObj.taxPrice = 0;
      taxObj.taxPrice = (taxObj.pst ?? 0) + (taxObj.hst ?? 0) + (taxObj.gst ?? 0)
    }
 
    return taxObj;
  }

  deleteRequest(){
    let endPoint = `/adjudication-queues/${this.requestQueueData.id}`

    this.http.delete(environment.apiUrl + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.statusCode == 200) {
        Swal.fire({ allowOutsideClick: false, title: "Info", text: "Request Deleted" }).then(res => {
          if(res.isConfirmed){
            window.location.reload()
          }
        })

      } else {
        Swal.fire({ allowOutsideClick: false, title: "Error", text: response.message });
      }
    },
      (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: "Info",
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: "Proceed",
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: "Error", text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      })
  }


  momentDateformat(date: any) {
    return moment(date).format('DD-MM-YYYY')
  }


  saveAndClose(id:any){
    sessionStorage.setItem("mailBody", this.body);
    this.closePopup(id)
  }

  closePopup(id: any) {
    console.log(id)
    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    $(`#${id}`).hide();
  }


  spouseform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(this.spouseDob.toISOString().split("T")[0]),
    email: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    healthPlan: new FormControl(''),
    insurer: new FormControl(''),
    gender: new FormControl('')
  });

  pureDependentform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    dob: new FormControl(''),
    // gender: new FormControl(''),
    age: new FormControl(''),
    phoneNum: new FormControl(''),
    coveredByAnotherPlan: new FormControl(''),
    carrierName: new FormControl(''),
    specialNeeds: new FormControl(''),
    postSecondaryStudent: new FormControl(''),
    graduationDate: new FormControl(''),
  });

  handleShowRequestDetails(queue: any) {
    console.log(queue)
    this.isSpouse = false;
    this.isDependent=false;
    this.requestQueueData = queue;
    this.spouseDetails = queue.data.spouseDetails;
    this.dependentDetails = queue.data.childrenDetails;
     if(queue.data.event == "spouse"){
      this.isSpouse = Object.keys(queue.data.spouseDetails).length > 0 ? true : false;
    }if(queue.data.event == "children"){
      // this.dependentDetails = this.dependentDetails.filter(item => !item.isBackdated)
      this.isDependent = queue.data.childrenDetails.length > 0 ? true : false;
    }
    if(this.isDependent){
      const updatedChildren = this.dependentDetails.map(child => ({
        ...child,
        gender: 'Male' // add new property
      }));

      this.dependentDetails = updatedChildren
    }
    if(this.isSpouse){
      const fullName = queue.data.spouseDetails.fullName.trim().split(/\s+/);
      this.spouseDetails = {
        ...this.spouseDetails,
        firstName: fullName[0],
        lastName: fullName.slice(1).join(' '),
        insurer:  queue.data.spouseDetails.insurer ?  queue.data.spouseDetails.insurer.trim() : "",
        coverage: "single",
        carrierName:  queue.data.spouseDetails.insurer ?  queue.data.spouseDetails.insurer.trim() : ""
      }
    }
    this.plansSummaryObj = queue.data.plans;
    this.notificationHistory = JSON.parse(queue.notificationHistory ?? "[]")
    this.reasonList_(this.notificationHistory)
  }

  getServiceTypeLabel(): string {
  const serviceType = this.requestQueueData?.serviceType;
  if (serviceType?.greenShildCustomer) return "Greenshield";
  if (serviceType?.equitableCustomer) return "Equitable";
  return "N/A"; // or empty string
}

  handleShowRequestDetails2(queue: any) {
    console.log(queue)
    this.isSpouse = false;
    this.isDependent=false;
    console.log(JSON.parse(queue.inputData))
    this.respondReason = `Dear ${queue.customer.firstName} ${queue.customer.lastName},`
    this.respondReason += `\n`
    this.respondReason += `\n`
    this.respondReason += `\n`
    this.respondReason += `Best Regards,\n GroupBenefitz Admin.`
    if(queue.data.event == "spouse"){
      this.isSpouse = Object.keys(queue.data.spouseDetails).length > 0 ? true : false;
    }if(queue.data.event == "children"){
      this.isDependent = queue.data.childrenDetails.length > 0 ? true : false;
    }
    console.log(queue)
    if(this.isSpouse){
      if(queue.data.spouseDetails.coveredByAnotherPlan){
        this.dependentCoverage = 'open'
      }
      const fullName = queue.data.spouseDetails.fullName.trim().split(/\s+/);
      console.log(fullName, "asdadsja")
      this.spouseform.patchValue({
        firstName: fullName[0],
        lastName: fullName.slice(1).join(' '),
        dob: moment(queue.data.spouseDetails.dob).format('MM-DD-YYYY'),
        email: queue.data.spouseDetails.email,
        coveredByAnotherPlan: queue.data.spouseDetails.coveredByAnotherPlan,
        healthPlan: 'single',
        insurer: queue.data.spouseDetails.insurer.trim(),
        gender: queue.data.spouseDetails.gender,
      });
    }
    this.requestQueueData = queue;
    this.queue = queue;

    this.adminStatus = '';
    this.provision = 'Yes'
    this.planEffectiveDate = moment(queue.data.effectiveDate, 'YYYY-MM-DD').format('MMM-DD-YYYY');
    console.log(this.planEffectiveDate, "planEffectiveDate333")
    this.spouseDetails = queue.data.spouseDetails;
    this.dependentDetails = queue.data.childrenDetails;
    this.plansSummaryObj = queue.data.plans;
    this.userEmail = queue.customer.contactInformations[0].primaryEmail;
    // this.notificationHistory = [{"text": "dependent added from member portal by member", "date": "18-03-25"}, {"text": "admin sent mail to greenshield", "date": "18-03-25"}, {"text": "greenshield approved the request with effective date from 01-03-25", "date": "19-03-25"}]



    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");

  
    let childCovered = 'none'
    let childCoveredCount = 0;
    if (this.isDependent ) {
      for (const cd of this.dependentDetails) {
        if (cd.coveredByAnotherPlan == true) {
          childCoveredCount++;
        }
      }

      if (this.dependentDetails.length == childCoveredCount) {
        childCovered = 'full'
      } else {
        childCovered = 'partial'
      }


      if (childCoveredCount == 0) {
        childCovered = 'none'
      }
    }

    let endPoint:any 
    if(!queue.data.isCorporateCustomer){
      endPoint = `/${queue.customerId}/customerPlans/${queue.data.event == 'children' ? 'dependent' : queue.data.event}/add`
    }else{
      endPoint = `/v2/${queue.customerId}/customerPlans/${queue.data.event == 'children' ? 'dependent' : queue.data.event}/add`
    }
    let enrollmentDate:any;
    if(this.dependentDetails && this.dependentDetails.length > 0) {
      enrollmentDate = this.dependentDetails[0]
    }
    this.finalEffectiveDate = queue.data.effectiveDate;
    this.childCovered = childCovered;
    let payload = {
      enrollmentDate: queue.data.effectiveDate,
      spouseCovered: this.spouseDetails.coveredByAnotherPlan == 'open' ? true : false,
      removeRoleBasedPlans: false,
      childCovered: childCovered,
      totalCount: this.dependentDetails.length - 1,
      totalCountIncluded: this.dependentDetails.length,
      isIncluded: queue.data.isPolicyChange
    }
    
    if(queue.data.isCorporateCustomer && queue.data.event == 'children'){
      payload.totalCount = this.dependentDetails.length;
      payload.totalCountIncluded =  this.dependentDetails.length;
    }

    // if(this.dependentType == 'multiple'){
    //   if(this.childrenDetails.length > 0) {
    //   if(!this.normalSpouseRegistration){
    //     if(this.childrenDetailsForNormalReg.length > 0) {
    //       payload.totalCount = this.childrenDetailsForNormalReg.length - 1;
    //       payload.totalCountIncluded = this.childrenDetails.length;
    //     }else{
    //       payload.totalCount = this.childrenDetails.length;
    //       payload.totalCountIncluded = this.childrenDetails.length;
    //     }
    //   }else{
    //      payload.totalCount = this.childrenDetailsForNormalReg.length;
    //       payload.totalCountIncluded = this.childrenDetails.length;
    //   }
    //   }
    // }

    console.log({ payload })

    let dataaaa:any;
    // commented
    // return;
    
   
  }



    public handleContinue(response:any, queue:any) {
    this._LoaderService.ShowLoader()
    this.showPlanDetails = true;
    let effectiveDate: any;

    let childCovered = 'none';
    let childCoveredCount = 0;
    if (this.dependentDetails && this.dependentDetails.length > 0) {
      for (const cd of this.dependentDetails) {
        if (cd.coveredByAnotherPlan == true) {
          childCoveredCount++;
        }
      }

      if (this.dependentDetails.length == childCoveredCount) {
        childCovered = 'full'
      } else {
        childCovered = 'partial'
      }


      if (childCoveredCount == 0) {
        childCovered = 'none'
      }
    }
    // commented
    // return;

    sessionStorage.removeItem("plansummarymain")
    sessionStorage.removeItem("plansskumain");
    sessionStorage.removeItem("plansummaryopt");
    sessionStorage.removeItem("plansummary");
    sessionStorage.removeItem("selectedPlans");
    sessionStorage.removeItem("totalAmount");
    sessionStorage.removeItem("totalAmountUI");

    if (response.status == 200 && !queue.data.isCorporateCustomer) {
      console.log(response?.data, 'asda')
      this.coverageChange = response?.data?.coverageChange;
      let prs = response?.data?.gsOrEqMemberStatus ?? {}
      let prsStatus: any = []
      const prsKeys = Object.keys(prs);
      if (prsKeys.length > 0) {
        for (const prk of prsKeys) {
          if (prs[prk] == true) {
            if (prk == 'greenShildCustomer') {
              prsStatus.push('GreenShield')
            }
            if (prk == 'hcdSecuremePlans') {
              prsStatus.push('HCD Secureme')
            }
            if (prk == 'equitableCustomer') {
              prsStatus.push('Equitable')
            }
            if (prk == 'phrCustomer') {
              prsStatus.push('PHR')
            }
            if (prk == 'waddelCustomer') {
              prsStatus.push('Waddel')
            }
          }
        }
      }
      // this.provisioningSites = prsStatus.toString() ?? ""


      console.log("calledoooo")
      let data__ = response?.data?.packages
      this.customerPlans = response?.data?.customerPlans;

      console.log(this.customerPlans, "custplans889")
      setTimeout(() => {

        const coverageMap: { [key: string]: string } = {
          STC: 'COUPLE',
          STF: 'FAMILY',
          CTF: 'FAMILY',
          CTS: 'SINGLE',
          FTS: 'SINGLE',
          FTC: 'COUPLE',
          F: 'FAMILY'
        };

        let targetCoverage = coverageMap[this.coverageChange];
        this.customerPlans.forEach(element => {
          const dom: HTMLElement = this.elementRef.nativeElement;

         
            console.log(element, "jiihhsh")
            if (element.isBundle) {


              let coverages = ['SINGLE', 'COUPLE', 'FAMILY'];
              let clicked = false;
              
               
              if ($("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()).length == 0) {
                for (const cov of coverages) {
                  const selector = "#plancheck" + element.planId + ".coverage" + cov.toUpperCase();
                  if ($(selector).length > 0 && !clicked) {
                    $(selector).click();
                    $(selector).prop("disabled", true);
                    clicked = true;
                  }
                }
              } else {
                const selector = "#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase();
                $(selector).click();
                $(selector).prop("disabled", true);
              }


            }
            else { 
              console.log(targetCoverage, "after else")
              if (targetCoverage && targetCoverage != '-') {
                // const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());

                // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
                console.log("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase())
                $("#plancheck" + element.planSelectionId2).click()
                $("#plancheck" + element.planId + ".coverage" + targetCoverage.toUpperCase()).prop("disabled", true);
              }
              else {
                console.log($("#plancheck" + element.planSelectionId2))
                $("#plancheck" + element.planSelectionId2).click()
                $("#plancheck" + element.planSelectionId2).prop("disabled", true);

              }
            }
          


        });
      }, 1000);

      this.selectedPlans_ = [];
      this.oldExistingPlans = []
      this.selectedTrues = []
      this.unSelectedPlans_ = []
      this.totalSummaryPrice = 0;

      for (let package_ of data__) {
        console.log(package_, 'asdaas2');

        let groupKeys_ = Object.keys(package_.groups);
        for (let i = 0; i < groupKeys_.length; i++) {
          let groups = groupKeys_[i];

          for (let j = 0; j < package_.groups[groups].length; j++) {
            let group = package_.groups[groups][j];

            for (let k = 0; k < group.plans.length; k++) {
              let plan = group.plans[k];
              let pan = plan.productAddonssNames;
              console.log(plan.isBundle, "bundled")

              for (let product of pan) {
                if (plan.productAddonss[product]) {
                  const paon = plan.productAddonss[product];

                  const selectedAddons = paon.filter((item: any) => item.selected);



                  if (selectedAddons && selectedAddons.length > 0) {
                    const unSelectedAddon = paon.find((item: any) => !item.selected);

                    console.log(unSelectedAddon)
                    if (!!unSelectedAddon && plan.selected) {
                      this.upgradeorDowngradeplans.push({
                        'name': unSelectedAddon?.name,
                        'addon': unSelectedAddon,
                        'isBundle': plan.isBundle
                      })
                    }
                    if (!unSelectedAddon && plan.selected) {
                      for (const selectedAddon of selectedAddons) {
                        const customerPlan = this.customerPlans.find((item: any) => (item.planId == selectedAddon.planId && (item.terminationDate == null || item.terminationDate == "")))
                        console.log(customerPlan, selectedAddon)
                        if (customerPlan.coverage1.toUpperCase() == selectedAddon.planCoverage) {
                          this.upgradeorDowngradeplans.push({
                            'name': selectedAddon?.name,
                            'addon': selectedAddon,
                            'isBundle': plan.isBundle
                          })
                        }
                      }
                    }
                    if (plan.selected) {
                      //check for the termination date
                      for (const selectedAddon of selectedAddons) {
                        this.upgradeorDowngradeplansSelected.push({
                          'name': selectedAddon?.name,
                          'addon': selectedAddon,
                          'isBundle': plan.isBundle
                        })

                      }
                    }
                  }
                  // Loop over the addonss for the plan
                  for (const paon_ of paon) {
                    console.log(paon_, '12345');

                    if (paon_.selected === true) {
                      // We can call the onCheckboxChange



                      this.selectedTrues.push({
                        id: paon_.id,
                        productId: paon_.productId,
                        planId: paon_.planId
                      });

                      paon_['checked'] = true;  // Mark the plan as checked
                      this.totalSummaryPrice += paon_.calculatedTax.total;
                      this.selectedPlans_.push(paon_);
                      this.oldExistingPlans.push(paon_);
                    } else {
                      this.unSelectedPlans_.push(paon_);
                    }
                  }
                }
              }
            }
          }
        }






        console.log(this.selectedPlans_, 'asd2342');
        console.log(this.unSelectedPlans_, 'asd23421');
        this.getPlanSummaryObject();
      }


      console.log('selectedTrues', this.selectedTrues)


      this.specialpackages = data__ ?? []


      //get the selected coverages



      // this.getCustomerData();
      // this.closeDependentmodal.nativeElement.click();
      // Swal.fire({allowOutsideClick: false, title: this.lang?.Info, text: response.message });
    }

    if (response.status == 200 && queue.data.isCorporateCustomer) {

      sessionStorage.setItem(
        "customerTierId",
        response.data.customer.customerTierId
      );
      sessionStorage.setItem("employeeshare", "0");
      this.mainarray = [];
      this.mainarrayValues = [];
      this.mainarrayFinal = [];
      this.modifiedBlocksPaidByCompany = '',
        this.modifiedBlocksCoveredByCompany = '',

        sessionStorage.setItem("planDetailsArrayBlock", "[]");
      this.effectiveEmployeeTotalContibution = 0;
      sessionStorage.setItem("totalAmount", "0");
      sessionStorage.setItem("totalAmountUI", "0");

      sessionStorage.setItem("allSelectedPlans", "[]");

      sessionStorage.setItem("plansummary", "[]");
      sessionStorage.setItem("selectedPlans", "{}");
      sessionStorage.setItem("selectedPlansLife", "{}");
      sessionStorage.setItem("plansummarymain", "[]");
      sessionStorage.setItem("plansummaryopt", "[]");
      sessionStorage.removeItem("Spousesignature")

      this.addbenificaryData = []
      // sessionStorage.setItem(
      //   "corporateStateId",
      //   response.data.workingProvince.id
      // );
      // sessionStorage.setItem(
      //   "corporateStateName",
      //   response.data.workingProvince.name
      // );
      // sessionStorage.setItem(
      //   "companyStateId",
      //   response.data.corporateProvince.id
      // );


      this.allFormData = {}
      this.formData = {}
      sessionStorage.setItem('plansummaryLife', '[]');
      sessionStorage.setItem('planssummarymainLife', '[]');


      setTimeout(() => {
        this.autoSelectCompanyPaidPlans();



        sessionStorage.setItem(
          "enrollmentdate",
          response.data.planEnrollmentDate
        );

      }, 2000);

      ///here
      sessionStorage.removeItem("paymentfail");
      this.companypaidproductid = [];
      this.disabledcompanypaidproductid = [];
      this.removedisabledcompanypaidproductid = [];
      this.adddisabledcompanypaidproductid = [];
      // this.applicantfirstname = this.capitalize(value.givenname);
      // this.planssummary = JSON.parse(
      //   sessionStorage.getItem("plansummary")
      // );



      console.log(response)
      this.specialpackages = [];
      this.packagesInBlocks = response.data.blocks;
      this.basepackages = response.data.packages;
      this.customerSelectedPlans = response.data.customerPlans

      setTimeout(() => {
        this.customerSelectedPlansValues(this.customerSelectedPlans)

      }, 2000);
      let companyplans = this.convertpackagesToPlans2(
        this.packagesInBlocks
      )[1];
      let baseplans = this.convertpackagesToPlans2(this.basepackages)[1];
      this.calculateBasePlanDeltasforCCplans(
        this.packagesInBlocks.coveredByCompany,
        baseplans,
        companyplans
      );
      this.calculateBasePlanCPplans(
        this.packagesInBlocks.paidByCompany,
        baseplans,
        companyplans
      );

      // //console.log(this.packagesInBlocks.paidByCompany)
      // //console.log(this.modifiedBlocksPaidByCompany)
      this.mainarrayValues = this.cobminedcommonfunction(
        // this.packagesInBlocks.paidByCompany,
        this.modifiedBlocksPaidByCompany,
        this.modifiedBlocksCoveredByCompany,
        this.packagesInBlocks.paidByEmployee
      );

      let allPackages: any = [];
      for (let key in this.mainarrayValues) {
        //this.consoleMessage(key)
        allPackages.push(this.mainarrayValues[key]);
      }

      console.log(allPackages)
      // this.mainarray = allPackages;





      let filteredMainArray = allPackages
        .map((element: any) => {
          // Map the groups
          let filteredGroups = element.groups.map((group: any) => {
            // Map the plans
            let filteredPlans = group.plans.map((plan: any) => {
              // Filter the productAddonss


              let filteredProductAddonss = Object.keys(plan.productAddonss).reduce(
                (acc: any, key) => {

                  // Filter the products where display is true
                  let filteredProducts = plan.productAddonss[key].filter((product: any) =>
                    product.hasOwnProperty('display') && product.display
                  );
                  // let filteredProducts = plan.productAddonss[key].map((product: any) => {
                  //   // Check if the 'display' key exists and is true
                  //   if (product.hasOwnProperty('display') && product.display) {
                  //     return product; // Keep the object as-is if display is true
                  //   }
                  //   const newProduct = {};
                  //   // console.log("Product replaced with empty object:", product, "New product:", newProduct);
                  //   return newProduct;
                  // });
                  const containsOnlyEmptyObjects = filteredProducts.every(
                    (product: any) => Object.keys(product).length === 0
                  );

                  if (containsOnlyEmptyObjects) {
                    console.log("filteredProducts contains only empty objects.");
                  } else {
                    acc[key] = filteredProducts;
                    console.log("filteredProducts contains non-empty objects.");
                  }
                  // if (filteredProducts.length > 0) {
                  //   acc[key] = filteredProducts;
                  // }
                  return acc;
                },
                {}
              );
              return {
                ...plan,
                productAddonss: filteredProductAddonss,
              };
            }).filter((plan: any) => Object.keys(plan.productAddonss).length > 0); // Remove plans without any matching productAddons

            return {
              ...group,
              plans: filteredPlans,
            };
          }).filter((group: any) => group.plans.length > 0); // Remove groups without any matching plans

          return {
            ...element,
            groups: filteredGroups,
          };
        })
        .filter((element: any) => element.groups.length > 0); // Remove elements without any matching groups


      console.log(filteredMainArray)

      this.mainarrayFinal = filteredMainArray

      console.log(this.mainarrayFinal)

      // this code needs to comment for single single in
      this.mainarrayFinal.forEach((element: any) => {
        element.groups.forEach((group: any) => {
          group.plans.forEach((plan: any) => {
            if (plan.productAddonss) {
              Object.keys(plan.productAddonss).forEach((key) => {
                // plan.productAddonss[key].forEach((product) => {
                const keys = ['planCoverage'];
                const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
                  self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
                );
                plan.productAddonss[key] = filteredData
                // });
              });
            }
          });

        });
      });

      this.mainarrayFinal.forEach((element: any) => {
        element.groups.forEach((group: any) => {
          if (group.categorization.paidByCompany == 1) {
            group.plans.forEach((plan: any) => {
              let pl = { ...plan, ...group.categorization }
              Object.keys(plan.productAddonss).forEach((key) => {
                let productLength = plan.productAddonss[key]?.display
                let displayingProductlengths = plan.productAddonss[key].filter((e: any) => { return e.dispaly == true })?.length
                // this.Displayproducts[key] = { 'productLength': productLength, 'displayingProductLength': displayingProductlengths }

                plan.productAddonss[key].forEach((product: any) => {

                  if (pl.isBundle) {
                    this.companypaidproductid.push(pl);
                  }
                  else {
                    this.companypaidproductid.push(product.planlevel);
                  }


                  const dom: HTMLElement = this.elementRef.nativeElement;

                  const plan: any = dom.querySelector("#plancheck" + product.id);

                  if (plan) {
                    plan.checked = false;
                  }
                  // $("#plancheck" + product.id).prop("checked", false);
                });
              });
            });
          }

          setTimeout(() => {
            if (group.categorization.coveredByCompany == 1) {
              group.plans.forEach((plan: any) => {
                Object.keys(plan.productAddonss).forEach((key) => {
                  plan.productAddonss[key].forEach((product: any) => {
                    // $("#plancheck" + product.id).prop("checked", false);
                    const dom: HTMLElement = this.elementRef.nativeElement;

                    const plan: any = dom.querySelector("#plancheck" + product.id);

                    if (plan) {
                      plan.checked = false;
                    }
                  });
                });
              });
            }
            if (group.categorization.paidByEmployee == 1) {
              group.plans.forEach((plan: any) => {

                if (plan.productAddonss) {
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      // $("#plancheck" + product.id).prop("checked", false);
                      const dom: HTMLElement = this.elementRef.nativeElement;

                      const plan: any = dom.querySelector("#plancheck" + product.id);

                      if (plan) {
                        plan.checked = false;
                      }
                    });
                  });
                }
              });
            }
          }, 1000);




        });
      });

      console.log(this.mainarrayFinal)
      this.mainarrayFinal.forEach((element: any) => {
        let coveragerray: any = []
        element.groups.forEach((group: any) => {

          group.plans.forEach((plan: any) => {
            let pl = { ...plan, ...group.categorization }
            Object.keys(plan.productAddonss).forEach((key) => {

              plan.productAddonss[key].forEach((product: any) => {
                coveragerray.push(product.planCoverage)

                if (pl.isBundle) {

                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + pl.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + pl.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + pl.id);
                    // //console.log(plan)


                    if (
                      coveragerray.includes("SINGLE") &&
                      coveragerray.includes("COUPLE") &&
                      coveragerray.includes("FAMILY")
                    ) {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                    }
                    else if (
                      coveragerray.includes("SINGLE") &&
                      coveragerray.includes("COUPLE")
                    ) {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                    }
                    else if (
                      coveragerray.includes("SINGLE") &&
                      coveragerray.includes("FAMILY")
                    ) {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                    }
                    else if (
                      coveragerray.includes("COUPLE") &&
                      coveragerray.includes("FAMILY")
                    ) {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                    }
                    else if (product.planCoverage === "SINGLE") {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                    }
                    else if (product.planCoverage === "COUPLE") {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                    }
                    else if (product.planCoverage === "FAMILY") {
                      if (plan) {
                        plan.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan2) {
                        plan2.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'none';
                        });
                      }
                      if (plan3) {
                        plan3.forEach((elem: any) => {
                          (elem as HTMLElement).style.display = 'block';
                        });
                      }
                    } else {
                      // Default case - hide all plans if coverage doesn't match expected
                    }



                  }, 1000);

                }
                else {
                  // this.companypaidproductid.push(product.planlevel);
                }


                // $("#plancheck" + product.id).prop("checked", false);
              });
            });
          });







        });
      });

      this.planAmount = ''

      sessionStorage.setItem("stateid", response.data.province.id);


      sessionStorage.setItem(
        "planDetailsArray",
        JSON.stringify(this.specialpackages)
      );
      sessionStorage.setItem(
        "planDetailsArrayBlock",
        JSON.stringify(this.mainarrayFinal)
      );


    }
    else {
      // Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
    }
    
    if (this.specialpackages && this.specialpackages.length > 0) {
      let filteredPackages_: any = [];
      console.log("called")
      //filter the repeated packages for medcan care
      for (let package_ of this.specialpackages) {
        console.log(package_, 'asdaas2')
        let groupKeys_ = Object.keys(package_.groups);
        for (let groups of groupKeys_) {
          for (let group of package_.groups[groups]) {
            for (let plan of group.plans) {
              let pan = plan.productAddonssNames
              for (let product of plan.productAddonssNames) {
                if (plan.productAddonss[product]) {
                  const paon = plan.productAddonss[product]
                  for (const paon_ of paon) {
                    if (paon_.selected == true) {
                      this.selectedPlans_.push(paon_);
                    }
                  }
                }
              }

            }
          }
        }
        console.log(this.selectedPlans_, 'asd2342')
        if (package_.id == 5) {
          let groupKeys_ = Object.keys(package_.groups);
          for (let groups of groupKeys_) {
            for (let group of package_.groups[groups]) {
              for (let plan of group.plans) {
                let pan = plan.productAddonssNames
                for (let product of plan.productAddonssNames) {

                  // plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id
                  if (filteredPackages_[product]) {
                    if (filteredPackages_[product]['planProductIds']?.includes(plan.productAddonss[product][0]?.planlevel.id) && filteredPackages_[product]['planProductIds'].includes(plan.productAddonss[product][0].product_id)) {
                      let index = pan.indexOf(product);
                      if (index !== -1) {
                        pan.splice(index, 1);
                      }
                    }
                  } else {
                    filteredPackages_[product] = { 'planProductIds': [] }
                    filteredPackages_[product]['planProductIds'] = [plan.productAddonss[product][0]?.planlevel.id, plan.productAddonss[product][0].product_id]
                  }

                  console.log(plan.productAddonss, product);

                }

                plan.productAddonssNames = pan;
              }
            }
          }
        }
      }

      // console.log(this.specialpackages)
    }
  }

   getGroups(data): any[] {
    return Array.isArray(data?.value) ? data.value : Object.values(data?.value ?? {});
  }

   public selectplan(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    disallowedPlanLevels: any
  ) {

    console.log(options)

    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    // if (options && options.length > 0) {
    //   let coverage = product.planCoverage;

    //   coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
    //     ? coverage
    //     : null;
    //   ////this.consoleMessage(obj)
    //   this.productobj = {
    //     id: product.id,
    //     productId: product.productId,
    //     name: product.name,
    //     planProductId: product.planProductId,
    //     price: this._decimalPipe
    //       .transform(product.price1 || product.price, '1.2-2')
    //       ?.replace(/,/g, ''),
    //     tax: this._decimalPipe
    //       .transform(
    //         product.calculatedTax ? product.calculatedTax.tax : 0,
    //         '1.2-2'
    //       )
    //       ?.replace(/,/g, ''),
    //     total: this._decimalPipe
    //       .transform(
    //         product.calculatedTax ? product.calculatedTax.total : 0,
    //         '1.2-2'
    //       )
    //       ?.replace(/,/g, ''),
    //     tax_details:
    //       product.bundledTaxes && product.bundledTaxes.length > 0
    //         ? product.bundledTaxes
    //         : product.taxesDataJSON,
    //     calculatedTax: product.calculatedTax,
    //     bundledProducts: product.bundledProducts,
    //     planCoverage: product.planCoverage,
    //     planLevel: product.planlevel ? product.planlevel.id : '',
    //     planLevelParent: product.planlevel ? product.planlevel.parentId : '',
    //     description: product.description,
    //     coverage: coverage,
    //   };

    //   let obj1: any = {
    //     packageId: plan.packageId,
    //     packageName: pckage.name,

    //     planproductname: this.productobj.name,

    //     groupid: plan.planLevel,
    //     groupName: group.name,
    //     id: plan.id,
    //     name: plan.name,
    //     planLevel: plan.planLevel ? plan.planLevel : group.id,
    //     planLevelParent: group.parentId,
    //     fusebillPlanID: plan.fusebillId,
    //     planFrequencyID: plan.frqMonthly,
    //     isBundle: plan.isBundle,
    //     coverage: coverage,
    //     planCoverage: product.planCoverage,
    //     bundledProducts: [],
    //     products: [],
    //   };
    //   obj1.products.push(this.productobj);
    //   this.planobjdata = obj1;

    //   this.openplanoptions(elementcv, options, plan, product);
    // }

    // else {

    let obj: any = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.finalEffectiveDate,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(product.calculatedTax.price),
      amountUI:
        '$' +
        this._decimalPipe.transform(product.calculatedTax.price, '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,
      planProductId: product.planProductId,
      price: this._decimalPipe
        .transform(product.price1 || product.price, '1.2-2')
        ?.replace(/,/g, ''),
      tax: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      total: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel ? product.planlevel.id : '',
      planLevelParent: product.planlevel ? product.planlevel.parentId : '',
      description: product.description,
      coverage: coverage,
    };

    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
    };
    obj1.products.push(this.productobj);
    //this.consoleMessage(obj1)
    this._LoaderService.ShowLoader()
    this.addtoplansummary(obj, obj1);
    setTimeout(() => {


      // this.openplanoptions(elementcv, options, plan, product)
      // this.openplanoptions(elementcv)


    }, 1000);

    // }
  }



    public addtoplansummary(obj: any, obj1: any) {
    this._LoaderService.ShowLoader()
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    //  console.log(obj1);
    // console.log(planSummary);
    // console.log('addroplansummaryplans');
    // console.log(planSummary.length);
    // console.log(obj.id);
    // console.log(obj);

    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);
    this.getPlanSummaryObject()

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;
      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj['gstPrice'] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj['hstPrice'] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;
      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj['pstPrice'] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj['qstPrice'] = 0;
    }

    obj['taxUI'] = '';
    if (obj['gstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['gstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
          '&nbsp;(GST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['pstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['pstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
          '&nbsp;(PST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['qstCheck']) {
      obj['taxUI'] += '<span>';
      if (obj['qstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
          '&nbsp;(QST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (obj['hstCheck']) {
      obj['taxUI'] += '<span> ';
      if (obj['hstPrice'] == 0) {
        obj['taxUI'] += '-';
      } else {
        obj['taxUI'] +=
          '$' +
          this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
          '&nbsp;(HST)';
      }
      obj['taxUI'] += '</span>';
    }

    if (
      !obj['hstCheck'] &&
      !obj['gstCheck'] &&
      !obj['pstCheck'] &&
      !obj['qstCheck']
    ) {
      obj['taxUI'] += '<span>-';

      obj['taxUI'] += '</span>';
    }

    // ////this.consoleMessage(object["taxUI"])

    obj['tax'] = obj1.products
      ? this._decimalPipe.transform(
        obj1.products?.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.tax;
        }, 0),
        '1.2-2'
      )
      : 0;
    obj['tax'] = parseFloat(obj['tax']);

    // obj["products"] =obj1
    obj['coverage'] = obj1.coverage;
    obj['planCoverage'] = obj1.planCoverage;
    obj['planLevelParent'] = obj1.planLevelParent;
    obj['planproductname'] = obj1.planproductname;

    obj['products'] = obj1.products;

    //this.consoleMessage(obj.planPrice)
    //this.consoleMessage(gstprice)
    //this.consoleMessage(hstprice)
    //this.consoleMessage(pstprice)

    //this.consoleMessage(qstprice)
    let pricecal = obj1.products.reduce((acc: any, calculatedTax: any) => {
      return acc + calculatedTax.total;
    }, 0);
    obj['totalPrice'] = parseFloat(pricecal);

    obj['totalUI'] = '$' + this._decimalPipe.transform(pricecal, '1.2-2');

    obj['total'] = this._decimalPipe.transform(pricecal, '1.2-2');

    //this.consoleMessage(obj1)

    obj['skuTotalPrice'] = parseFloat(obj1.products.reduce(
      (acc: any, calculatedTax: any) => {
        return acc + calculatedTax.total;
      },
      0
    ))

    let updatedSum = this.addtosum(obj.totalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem('plansskumain', JSON.stringify(this.plansskumain));
    console.log("setting here");
    sessionStorage.setItem(
      'plansummarymain',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'plansummaryopt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
    let planSummaryData = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

    // if (planSummary.length > 0 || planSummaryData.length > 0) {
    //   this.plansnexttab = false;

    // } else {
    //   this.plansnexttab = true;
    // }
    if (updatedSum > 0) {
      this.cartcheckvalue = false;
    } else {
      this.cartcheckvalue = true;
    }

    setTimeout(() => {

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      console.log(this.planssummarymain)
      var total = 0;
      for (let i = 0; i < this.planssummarymain.length; i++) {
        if (obj.planproductname.includes("La Vie")) {
          console.log(this.planssummarymain[i].planLevel, "assssiiiooo")
          if (this.planssummarymain[i].planLevel == 18) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              // const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
              console.log(dom.querySelector("#plancheck792" + ".coverage" + obj.coverage), "iiiooooouu")
              $("#plancheck792" + ".coverage" + obj.coverage.toUpperCase()).click()
            }
            break;
          }
          else {

            // const dom: HTMLElement = this.elementRef.nativeElement;
            // // const plan: any = dom.querySelector(`#plancheck792`)
            // const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

            console.log(obj.coverage, "ioasaddahhdh", $("#plancheck792" + ".coverage" + obj.coverage.toUpperCase()))
            setTimeout(() => {
              $("#plancheck792" + ".coverage" + obj.coverage.toUpperCase()).click()
              // this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
            }, 1000);
          }
        }
      }

      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);

      if (this.planAmount > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }



      this.showPlanDetails = false;
      this._LoaderService.hide()
      // here we can call the select plans one sudeep
    }, 100);
  }


    public addtosum(amount: any) {
    //this.consoleMessage("addtosum"+amount)

    // amount = Math.round((amount + Number.EPSILON) * 100) / 100;

    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount') || '0.00'
    );

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount);

    //this.consoleMessage("selectedPlansAmount"+selectedPlansAmount)
    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '') ?? '0'
    );

    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      ?.replace(/,/g, '');

    return selectedPlansAmount;
  }

   public unselectplan(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    disallowedPlanLevels: any
  ) {
    console.log(elementcv, "unselected")

    // this.planCoverageName = ''
    // this.insuranceplanid =''

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    let obj = {
      // enrollmentDate: moment(
      //   this.userForm.get("planenrollmentdate").value,
      //   "MM-DD-YYYY"
      // ).format("YYYY-MM-DD"),
      enrollmentDate: this.finalEffectiveDate,
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3]),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3]),
      amountUI: '$' + this._decimalPipe.transform(plandetailsobj[3], '1.2-2'),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == '' ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == 'null'
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == '' ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == 'null'
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == '' ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == 'null'
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == '' ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == 'null'
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == '' ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == 'null'
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == '' ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == 'null'
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == 'true' ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      //  "disallowedPlanLevels":plandetailsobj[11]
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != 'null') {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ['SINGLE', 'COUPLE', 'FAMILY'].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,
      planProductId: product.planProductId,
      price: this._decimalPipe
        .transform(product.price1 || product.price, '1.2-2')
        ?.replace(/,/g, ''),
      tax: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.tax : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      total: this._decimalPipe
        .transform(
          product.calculatedTax ? product.calculatedTax.total : 0,
          '1.2-2'
        )
        ?.replace(/,/g, ''),
      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel ? product.planlevel.id : '',
      planLevelParent: product.planlevel ? product.planlevel.parentId : '',
      description: product.description,
      coverage: coverage,
    };

    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
    };
    obj1.products.push(this.productobj);

    this.handleDisableCheckAndUnCheck(true, false, obj)
    this.removeplansummary(obj);
    setTimeout(() => {

      // this.openplanoptions(elementcv)


    }, 1000);
  }


    public removeplansummary(obj: any) {
    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    console.log(obj);


    this.getPlanSummaryObject()
    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    console.log(planSummary)


    if (planSummary) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      ////this.consoleMessage(index)

      if (index > -1) {
        // console.log(index);
        planSummary.splice(index, 1);

      } else {
        return;
      }

      // ////this.consoleMessage(planSummary)
      // ////this.consoleMessage(planSummary.length)
      ////this.consoleMessage("beforeremoveplans")
      let selectedPlans = JSON.parse(
        sessionStorage.getItem('selectedPlans') || '[]'
      );
      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      ////this.consoleMessage("newselectedPlans")
      ////this.consoleMessage(newselectedplans)
      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));
      // this.removeslectplans(obj.id,planSummary.length)

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;
        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj['gstPrice'] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;

        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);
      } else {
        obj['hstPrice'] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;
        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);
      } else {
        obj['pstPrice'] = 0;
      }

      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj['qstPrice'] = 0;
      }
      obj['taxUI'] = '';
      if (obj['gstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['gstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['gstPrice'], '1.2-2') +
            '&nbsp;(GST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['pstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['pstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['pstPrice'], '1.2-2') +
            '&nbsp;(PST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['qstCheck']) {
        obj['taxUI'] += '<span>';
        if (obj['qstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['qstPrice'], '1.2-2') +
            '&nbsp;(QST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (obj['hstCheck']) {
        obj['taxUI'] += '<span> ';
        if (obj['hstPrice'] == 0) {
          obj['taxUI'] += '-';
        } else {
          obj['taxUI'] +=
            '$' +
            this._decimalPipe.transform(obj['hstPrice'], '1.2-2') +
            '&nbsp;(HST)';
        }
        obj['taxUI'] += '</span>';
      }

      if (
        !obj['hstCheck'] &&
        !obj['gstCheck'] &&
        !obj['pstCheck'] &&
        !obj['qstCheck']
      ) {
        obj['taxUI'] += '<span>-';

        obj['taxUI'] += '</span>';
      }

      // ////this.consoleMessage(object["taxUI"])

      obj['tax'] = parseFloat(
        this._decimalPipe.transform(
          gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      (obj['totalPrice'] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj['totalUI'] =
          '$' +
          this._decimalPipe.transform(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice,
            '1.2-2'
          ));

      obj['total'] = parseFloat(
        this._decimalPipe.transform(
          obj.planPrice + gstprice + hstprice + pstprice + qstprice,
          '1.2-2'
        ) ?? ''
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];

      planSummary.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });
      console.log("setting here2");

      sessionStorage.setItem(
        'plansummarymain',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'plansummaryopt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('plansummary', JSON.stringify(planSummary));
      let planSummaryLife = JSON.parse(sessionStorage.getItem('plansummaryLife') || '[]');

      // if (planSummary.length > 0 || planSummaryLife.length > 0) {
      //   this.plansnexttab = false;
      // } else {
      //   this.plansnexttab = true;
      // }
      if (updatedSum > 0) {
        this.cartcheckvalue = false;
      } else {
        this.cartcheckvalue = true;
      }
    }

    setTimeout(() => {
      // this.planssummarymain = JSON.parse(
      //   sessionStorage.getItem('plansummarymain') || '[]'
      // );

      // var total = 0;
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      // }

      // this.planssummarymainLife = JSON.parse(
      //   sessionStorage.getItem('planssummarymainLife') || '[]'
      // );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      // for (let i = 0; i < this.planssummarymainLife.length; i++) {
      //   total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      // }
      for (let i = 0; i < this.planssummarymain.length; i++) {
        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }
      //this.consoleMessage(total);

      this.planAmount = this._decimalPipe
        .transform(total, '1.2-2')
        ?.replace(/,/g, '');
      sessionStorage.setItem('totalAmount', this.planAmount);
    }, 100);


    for (let i = 0; i < this.planssummarymain.length; i++) {
      if (this.planssummarymain[i].disallowedPlanLevels != null) {
        let disallowed_plans = this.planssummarymain[i].disallowedPlanLevels.split(',');
        const dom1: HTMLElement = this.elementRef.nativeElement;
        for (let i = 0; i < disallowed_plans.length; i++) {
          // console.log(disallowed_plans[i]);
          // console.log(disallowed_plans[i]);
          setTimeout(() => {
            let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)

            if (elem != null) {
              if (!elem.disabled) {

                elem.disabled = true
              }
            }
          }, 100);

        }
      }
    }
  }


    public removetosum(amount: number) {
    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount')?.replace(/,/g, '') ?? '0'
    );

    selectedPlansAmount = selectedPlansAmount - amount;
    sessionStorage.setItem(
      'totalAmount',
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '') ?? '0'
    );
    sessionStorage.setItem(
      'totalAmountUI',
      '$' +
      this._decimalPipe
        .transform(selectedPlansAmount, '1.2-2')
        ?.replace(/,/g, '')
    );

    this.planAmount = this._decimalPipe
      .transform(selectedPlansAmount, '1.2-2')
      ?.replace(/,/g, '');
    return selectedPlansAmount;
  }

    public handleDisableCheckAndUnCheck(unchecked: any, checked: any, obj: any) {
    console.log(obj)

    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }


    if (planSummary && planSummary.length > 0) {
      ////this.consoleMessage("removeinplanid"+obj.id)
      let index: any = this.getslectedplans(obj.id);
      console.log(index)
      console.log(planSummary)

      if (index > -1) {
        // console.log(index);
        let element = planSummary[index];
        if (element.isBundle) {

          $("#plancheck" + element.id + ".coverage" + element.coverage.toUpperCase()).prop("disabled", false);
          console.log($("#plancheck" + element.id + ".coverage" + element.coverage.toUpperCase()), "called3322")

        }
        else {
          console.log(element?.coverage, "after else")
          if (element?.coverage) {
            // const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage.toUpperCase());

            // $("#plancheck" + element.planSelectionId2 + ".coverage"+element.coverage).click()
            $("#plancheck" + element.id + ".coverage" + element.coverage.toUpperCase()).prop("disabled", false);
          }
          else {
            // check here once
            $("#plancheck" + element.id).prop("disabled", false);

          }
        }

      } else {
        return;
      }
    }

  }


    public getslectedplans(planid: number) {
    ////this.consoleMessage(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    return selectedPlans[planid];
  }

   public onCheckboxChange(
    e: any,
    allowMultiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    coverage: any
  ) {
    console.log("called1", plan)
    // e.preventDefault();
    // let multiple = allowMultiple ? Boolean(allowMultiple.data[0]) : false;

    let multiple = allowMultiple == true ? true : false;

    console.log(multiple)

    if (e.target.checked == false && product.selected == true) {
      this.unselected.push({ planId: product.planId, packId: pckage.id })
    }
    else {
      this.unselected = this.unselected.filter((ele) => (
        ele.planId != product.planId
      ))
    }

    if (e.target.checked) {
      console.log("inside checked")
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)
      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      console.log(samePlanIdElements)

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;
        //  console.log(elem)

        if (element.checked) {
          element.checked = false;
          this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);

        }
      }
      e.target.checked = true
      e.target.disabled = true
      // if(this.isUpgradeOrDowngrade == 'downgrade'){
      //   e.target.disabled = true
      // }
    } else {
      //      this.planCoverageName = ''
      // this.insuranceplanid =''
    }

    // console.log(multiple)

    // console.log(plan)
    // console.log(product)


    //this.consoleMessage(disallowedPlanLevels)

    console.log(disallowedPlanLevels)

    if (disallowedPlanLevels != null) {
      //this.consoleMessage(disallowedPlanLevels)
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      // disallowed_elements.forEach((elem: any) => {

      // console.log(disallowed_elements)

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        // elementcv.checked=false

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        //this.consoleMessage(plandetailsobj)

        // console.log(disallowed_plans)   //[1,10,19,20,21]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[20]) //[10]
        // console.log(plandetailsobj[12])  //[24]
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[19])
        // console.log(plandetailsobj[21])


        // console.log(typeof plandetailsobj[21])
        // console.log(plandetailsobj[12])
        // console.log(plandetailsobj[13])
        // console.log(plandetailsobj[20])


        let isBundle = plandetailsobj[21] == "true" ? true : false
        // console.log(isBundle)
        if (e.target.checked) {

          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  console.log("1")
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  console.log("2")

                  console.log(elem)

                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  console.log(elem)

                  if (elem.checked) {
                    console.log("checkehd")
                    elem.checked = false;
                    this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                  }

                  // elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  console.log("4")
                  console.log(elem)
                  // elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

            // else {
            //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
            //     //  elem.checked=false
            //     elem.disabled = false;
            //   }
            // }
          }
          if (elem.checked) {

            console.log("elechecked")

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked1")
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  console.log("elechecked2")
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }
      }
    }

    // let sameplanclassname = `newPlan${plan.id}`
    let covergaClassNmae = `coverage${coverage.toUpperCase()}` // //////this.consoleMessage(e)
    // let classname = e.target.className.replace(sameplanclassname, '').replace(covergaClassNmae, '');
    // classname = classname.split(' ').join('.').replaceAll('..', '.');

    // console.log(classname)
    // console.log(sameplanclassname)
    const getValidSelector = (className: string, planId: string, coverage: string) => {
      // Remove the specific plan and coverage classes
      let baseClasses = className
        .replace(`newPlan${planId}`, '')
        .replace(`coverage${coverage.toUpperCase()}`, '')
        .trim();

      // Split into individual classes and filter out empty strings
      const classes = baseClasses.split(' ').filter(c => c);

      // Join with dots and ensure it starts with a dot for class selection
      return '.' + classes.join('.');
    };

    // Usage in your function
    const sameplanclassname = `newPlan${plan.id}`;
    const coverageClassName = `coverage${coverage.toUpperCase()}`;

    // Create valid selector
    const selector = getValidSelector(e.target.className || '', plan.id, coverage);

    // Now use the selector
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll(selector);
    // //////this.consoleMessage(classname)
    // const dom: HTMLElement = this.elementRef.nativeElement;
    // const elements = dom.querySelectorAll(classname);
    // const elements = dom.querySelectorAll(e.target.className);

    // const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);

    // //////this.consoleMessage(elements);

    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {


        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i]
          element = elem;

          if (element.checked) {
            this.unselectplan(elem, options, plan, product, pckage, group, disallowedPlanLevels)
            element.checked = false;
          }


        }



        e.checked = true;
        e.target.checked = true;

      } else {

      }
    } else {
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {
        this.selectplan(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
      } else {
        this.unselectplan(e.target, options, plan, product, pckage, group, disallowedPlanLevels);
      }
    }, 10);
  }

  public isGroupsNotEmpty(groups: any): boolean {
    if (Object.keys(groups).length > 0) {
      Object.keys(groups).forEach(element => {

        if (groups[element].length > 0) {
          groups[element].map(ele => {

            if (ele.plans?.length > 0) {
              this.displayPackage = true;
              return this.displayPackage
            }
          });
        }
      })
    }

    return this.displayPackage
  }

  public addtoslectplans(planid: number, plansumamryindex: number) {
    ////this.consoleMessage("beforeaddtoplans")
    ////this.consoleMessage(planid)
    ////this.consoleMessage(plansumamryindex)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    ////this.consoleMessage(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.consoleMessage("afteraddtoplans")
    ////this.consoleMessage(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

    getPlanSummaryObject() {
    console.log(this.oldExistingPlans);

    let selectedPlans: any = sessionStorage.getItem("plansummarymain");
    if (selectedPlans) {
      selectedPlans = JSON.parse(selectedPlans);
    } else {
      selectedPlans = []; // Set a default value if the session storage is empty or null
    }

    let object_: any = []

    console.log('selectedPlans', selectedPlans)
    // for(const i of this.selectedPlans_){
    for (const i of selectedPlans) {
      // let oldPlanObj = this.oldExistingPlans.find(item => (item.planlevel.packageId == i.planlevel.packageId && item.planlevel.parentId == i.planlevel.parentId))
      let oldPlanObj = this.oldExistingPlans.find(item => (item.planlevel.packageId == i.packageId && item.planlevel.parentId == i.planLevelParent))
      let obj = {
        packageName: oldPlanObj?.description ?? "",
        oldPlan: {
          plan: oldPlanObj?.name + ' ' + `(${oldPlanObj?.planCoverageUI})`,
          coverage: oldPlanObj?.planCoverageUI ?? "",
          tax: oldPlanObj?.calculatedTax?.tax ?? 0,
          price: oldPlanObj?.calculatedTax?.price ?? 0,
          total: oldPlanObj?.calculatedTax?.total ?? 0,
        },
        newPlan: {
          // packageName: i?.description2.replace('<br>','') ?? "",
          // plan: i.name + ' ' + `(${i.planCoverageUI})`,
          // coverage: i?.planCoverageUI ?? "",
          // tax: i?.calculatedTax?.tax ?? 0,
          // price: i?.calculatedTax?.price ?? 0,
          // total: i?.calculatedTax?.total ?? 0,
          packageName: i?.packagename ?? "",
          plan: i.name + ' ' + `(${i.coverage})`,
          coverage: i?.planCoverageUI ?? "",
          tax: i?.tax ?? 0,
          price: i?.amount ?? 0,
          total: i?.total ?? 0,
        }
      }
      object_.push(obj)
    }

    console.log(object_)
    this.plansSummaryObj = object_;
  }

    public autoSelectCompanyPaidPlans() {
    this._LoaderService.ShowLoader()
    // console.log(this.companypaidproductid)
    this.companypaidproductid = this.companypaidproductid.filter(
      (item: any) => item !== undefined && item !== null
    );

    var result = this.companypaidproductid.reduce((unique: any, o: any) => {
      if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
        unique.push(o);
      }
      return unique;
    }, []);
    console.log(result);

    // this.companypaidproductid.forEach((element, index) => {

    result.forEach((element: any, index: any) => {


      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        // const plan: any = dom.querySelector("#plancheck" + element.id);
        // this.renderer.selectRootElement("#plancheck" + element.id).click()

        if (element.isBundle) {
          let productKeyArray: any = Object.keys(element.productAddonss)
          for (let productkey of productKeyArray) {
            //console.log(productkey)
            //console.log(element.productAddonss)
            //console.log(productKeyArray)
            for (let i = 0; i < element.productAddonss[productkey].length; i++) {
              //console.log(element.productAddonss[productkey][i])
              let coverage = element.companyPaidCoverage?.replace("SELECTIVE_", "")
              console.log(coverage)
              if (coverage && coverage != "DIRECT") {
                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    coverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  console.log(targetElement)
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  if (targetElement.disabled) {
                    targetElement.disabled = false
                    targetElement.click();
                    break;
                  }
                  else {
                    targetElement.click();
                    break;
                  }




                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + coverage).click()

              }
              else {

                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    element.productAddonss[productkey][i].planCoverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  console.log(targetElement)
                  if (targetElement.disabled) {
                    console.log("disabled click")
                    targetElement.disabled = false
                    targetElement.click();
                  }
                  else {
                    console.log("click")
                    console.log(elementSelector)
                    console.log($(elementSelector).length)
                    setTimeout(function() {
                        $(elementSelector).click();
                    }, 1000);
                  }

                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + element.productAddonss[productkey][i].planCoverage).click()

              }

            }

          }

          // Object.keys(element.productAddonss).forEach((key) => {
          //   element.productAddonss[key].forEach((product: any) => {
          //    //console.log(product)
          //    let coverage = element.companyPaidCoverage?.replace("SELECTIVE_","")
          //    //console.log(coverage)
          //   //  //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage))
          //   //   // //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + covergae))
          //     // this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage).click()

          //     if(coverage!="DIRECT"){
          //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage).click()

          //     }
          //     else{
          //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + product.planCoverage).click()
          //     }

          //   })
          // })

        }
        else {
          this.renderer.selectRootElement("#plancheck" + element.id).click()
        }
      }, 100);

    });

    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

      //this.consoleMessage(selectplans)

      //console.log(selectplans)
      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          element.products.forEach((product: any, index: any) => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck" + product.id);

            if (plan) {
              plan.disabled = true;
            }
          })

        }
      });
    }, 2000);
    // this.mainarrayFinal.forEach((element: any) => {
    //   element.groups.forEach((group: any) => {
    //     group.plans.forEach((plan: any) => {
    //       if (plan.productAddonss) {
    //         Object.keys(plan.productAddonss).forEach((key) => {
    //           // plan.productAddonss[key].forEach((product) => {
    //           const keys = ['planCoverage'];
    //           const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
    //             self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
    //           );
    //           plan.productAddonss[key] = filteredData
    //           // });
    //         });
    //       }
    //     });

    //   });
    // });
    //this.consoleMessage(this.mainarray)

    this.mainarrayFinal.forEach((element: { groups: any[]; }) => {
      element.groups.forEach((group: { categorization: { paidByCompany: number; }; plans: any[]; }) => {
        // //this.consoleMessage(element.groups)
        if (element.groups.length == 1) {
          // //this.consoleMessage(group)
          if (group.categorization.paidByCompany == 1) {
            group.plans.forEach((plan: { productAddonss: { [x: string]: any[]; }; }) => {
              Object.keys(plan.productAddonss).forEach((key) => {
                plan.productAddonss[key].forEach((product: { id: any; }) => {
                  this.disabledcompanypaidproductid.push({ id: product.id });
                  const dom: HTMLElement = this.elementRef.nativeElement;

                  const plan: any = dom.querySelector("#plancheck" + product.id);

                  if (plan) {
                    plan.checked = false;
                  }
                  // $("#plancheck" + product.id).prop("checked", false);
                });
              });
            });
          }
        }
      });
    });


    this.disabledcompanypaidproductid.forEach((element: { id: string; }, index: any) => {
      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        const plan: any = dom.querySelector("#plancheck" + element.id);

        // plan.disabled=true
      }, 100);
    });
    // if (packagesInBlocks && packagesInBlocks.paidByCompany) {
    //   for (const cpPackage of packagesInBlocks.paidByCompany) {
    //     for (const cpGroup of cpPackage.groupsCP) {
    //       for (const cpPlan of cpGroup.plans) {

    //         for(const product1 in cpPlan.productAddonss){
    //           //this.consoleMessage(product1)
    //           //this.consoleMessage(cpPlan.productAddonss[product1])
    //           $("#plancheck"+cpPlan.productAddonss[product1][0].id).click();

    //         }

    //       }
    //     }
    //   }
    // }
    // this.toastrService.success("Company paid plans are all selected", "");

  }


    calculateBasePlanDeltasforCCplans(ccplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

    //console.log(ccplanspackages)
    let modifiedCCplanPackages: any = [];
    //console.log(baseplans)
    for (let i = 0; i < ccplanspackages?.length; i++) {
      let modifiedCCPackage = ccplanspackages[i];
      //this.consoleMessage(ccplanspackages[i].name)
      //this.consoleMessage(ccplanspackages[i].id)
      let CCplansgroups = ccplanspackages[i].groupsCC;

      modifiedCCPackage.groupsCC = [];
      for (let CCplangroup of CCplansgroups) {
        let modifiedCCgroup = CCplangroup;

        let bbCoverage = baseplans.filter((bb: any) => { return bb.packageId == modifiedCCPackage.id && bb.planLevel_parentId == modifiedCCgroup.parentId })

        let selectedCoverage = bbCoverage[0]?.companyPaidCoverage ?? "DIRECT"

        // let selectedCoverage = CCplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"

        if (selectedCoverage == "null" || selectedCoverage == "" || selectedCoverage == " ") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        //console.log(selectedCoverage)
        let CCplans = CCplangroup.plans;
        //console.log(CCplangroup)

        modifiedCCgroup.plans = [];
        for (let CCplan of CCplans) {
          let modifiedCCplan = CCplan;
          //this.consoleMessage(CCplan.id);
          //this.consoleMessage(CCplan.isBundle);
          //this.consoleMessage(CCplan.name);

          CCplan.planLevel_parentId = CCplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CCplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];
          console.log(CCplan)
          console.log(CCplan.productAddonss[CCplan.name])

          if (CCplan.isBundle) {
            //this.consoleMessage("BundlePlan")

            //this.consoleMessage(baseplans)
            //console.log(baseplans)
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {



              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {
              //this.consoleMessage(plan)
              //cp_plans

              //this.consoleMessage(CCplan.packageId,plan.packageId)
              //this.consoleMessage(CCplan.planLevel_parentId,plan.planLevel_parentId)
              //this.consoleMessage(CCplan.planLevel,plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            //this.consoleMessage(filtered_base_plans);

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];


            //console.log("length" + filtered_base_plans.length)
            //console.log(filtered_base_plans)
            //console.log(filtered_compnay_plans)

            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {


              var filtered_base_plans2 = filtered_base_plans.filter(function (plan: { id: any; }) {
                return (
                  CCplan.id == plan.id
                );
              });
              var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan: { id: any; }) {


                return (
                  CCplan.id == plan.id
                );
              });
              selectedBasePlan = filtered_base_plans2[0];
              selectedCompnayPlan = filtered_compnay_plans2[0];
            }

            //console.log(selectedBasePlan)
            //console.log(selectedCompnayPlan)
            //console.log("name" + selectedBasePlan?.name)
            if (selectedBasePlan) {
              // //this.consoleMessage(selectedBasePlan)
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
              let selectedBaseplanProductsArray2: any = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                  selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                }

                let remainigProdcuts = selectedCCplanProductarray.length - selectedBaseplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray2[selectedBaseplanProductsArray2.length - 1]);
                  }
                }
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                // Direct Coverage Method
                // setTimeout(() => {
                if (selectedCoverage == "DIRECT") {
                  selectedBaseplanProductsArray = this.DirectCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                  //console.log(selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedBaseplanProductsArray = this.selectiveSingleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedBaseplanProductsArray = this.selectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedBaseplanProductsArray = this.selectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }

                //console.log(selectedBaseplanProductsArray)
                // }, 1000)

                // let productCoverageFound = false;
                // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                //   for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

                //     if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
                //       productCoverageFound = true
                //       selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
                //       break;
                //     }


                //   }
                //   if (!productCoverageFound) {



                //     selectedBasePlan = {};
                //     selectedBaseplanProduct = {};
                //     selectedBaseplanProduct.calculatedTax = {};
                //     selectedBaseplanProduct.calculatedTax.price = 0;
                //     selectedBaseplanProduct.calculatedTax.tax = 0;
                //     selectedBaseplanProduct.calculatedTax.total = 0;
                //     selectedBaseplanProduct.name = "NA";
                //     selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                //     selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



                //   }

                // }
                // //this.consoleMessage(selectedBaseplanProductsArray)
                // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                //this.consoleMessage(selectedBaseplanProductsArray)
              }
            }
            else {
              //console.log("elseStatement")
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }


            //console.log(selectedBaseplanProductsArray)
            if (selectedCompnayPlan) {
              // selectedCompanyplanProduct = selectedCompnayPlan.productAddonss[selectedCompnayPlan.name][0]
              selectedCompanyplanProductsArray =
                selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];
              // //this.consoleMessage(selectedCompanyplanProductsArray)
              // //this.consoleMessage(selectedCompnayPlan.name)

              let selectedCompanyplanProductsArray2: any = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
                  selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
                }
                //this.consoleMessage(selectedCompanyplanProductsArray)

                let remainigProdcuts = selectedCCplanProductarray.length - selectedCompanyplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray2[selectedCompanyplanProductsArray2.length - 1]);
                  }
                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2
                //this.consoleMessage(selectedCompanyplanProductsArray)

              }
              else {

                //console.log(selectedCCplanProductarray)
                // let productCoverageFound = false;
                // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                //   for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

                //     if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
                //       productCoverageFound = true
                //       selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
                //       break;
                //     }


                //   }
                //   if (!productCoverageFound) {


                //     selectedCompanyplanProduct = {};
                //     selectedCompanyplanProduct.calculatedTax = {};
                //     selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
                //     selectedCompanyplanProduct.name = "NA";
                //     selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                //     selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



                //   }

                // }
                // selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

                // // setTimeout(() => {
                if (selectedCoverage == "DIRECT") {
                  selectedCompanyplanProductsArray = this.CompanyDirectCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                  //console.log(selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }


                // // }, 1000)


                //console.log(selectedCompanyplanProductsArray)


              }


            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }
              //console.log(selectedCompanyplanProductsArray)
              //this.consoleMessage(selectedCompanyplanProductsArray)
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCCplan.products = []



            for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              //console.log(selectedBaseplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];
              let selectedCCplanProduct = selectedCCplanProductarray[i];
              //console.log(selectedCCplanProduct)
              //console.log(selectedCompanyplanProductsArray[i])
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );


              let employeeTax =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );
              //console.log(deltaplanPrice)


              //console.log(selectedBaseplanProduct.calculatedTax.price)

              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                // companyTax = employeeTax
                companyTax = 0  ////when there is no base planproduct
                // companyTaxPercentage = employeeTaxPercentage
                companyTaxPercentage = "0%" //when there is no base planproduct

              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice < 0) {
                deltaplanPrice = 0
                baseplanPrice = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.price
                );
                baseplanTaxorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.tax
                );
                baseplanTax = adjustWith2DecimalsForUI(
                  baseplanPrice * companyTax
                );
                baseplanTotalorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.total
                );
                baseplanTotal = adjustWith2DecimalsForUI(
                  baseplanPrice + baseplanTax
                );
              }
              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice *
              //   (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
              let planName = `${CCplan.name} (${upgradeText})`;
              let compnayShareStatement = `${CCplan.name} Contribution`;
              let employeeShareStatement = `${CCplan.name} upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                selectedCoverage
              };

              //this.consoleMessage(obj)

              console.log(obj)
              let ccProduct: any = {}
              ccProduct.upgradeCalculation = obj;
              modifiedCCplan.products.push(ccProduct)
              modifiedCCplan.upgradeCalculation = obj;


            }
            modifiedCCgroup.plans.push(modifiedCCplan);

          }
          else {
            let selectedCCplanNamearray = Object.keys(CCplan.productAddonss)

            let selectedCCplanProductarray: any = []
            for (let name of selectedCCplanNamearray) {
              selectedCCplanProductarray = selectedCCplanProductarray.concat(CCplan.productAddonss[name])
            }
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            //this.consoleMessage(filtered_base_plans)

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            console.log("length" + filtered_base_plans.length)
            console.log(filtered_base_plans)
            console.log(filtered_compnay_plans)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {
              //this.consoleMessage(filtered_base_plans.length)

            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = []
            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                console.log(planname)
                console.log(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  selectedBaseplanProductsArray.push(products[0]);

                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  selectedbaseplanproduct = products[products.length - 1]; //

                  for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                    selectedBaseplanProductsArray.push(products[i]);
                  }
                  /* Added for in the case of medacan year roudn care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                  console.log(products.length)
                }
              }
              console.log(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.tax)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.total)
            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";


              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }

            let CCplanProduct;
            let CCproductslength

            for (let planname in CCplan.productAddonss) {
              let products = CCplan.productAddonss[planname];
              CCproductslength = products.length
              console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
                // selectedCompnayPlan= filtered_compnay_plans[0]
              } else {
                CCplanProduct = products[products.length - 1]; //
                /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                Selecting last product(highest) in this case */
                //this.consoleMessage(products.length)
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = []

            if (selectedCompnayPlan) {
              for (let planname in selectedCompnayPlan.productAddonss) {
                //this.consoleMessage(planname)
                //this.consoleMessage(selectedCompnayPlan.productAddonss[planname])
                let products = selectedCompnayPlan.productAddonss[planname];

                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedcompanyplanproduct = products[0];
                  selectedCompanyplanProductsArray.push(
                    products[0]
                  );
                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  selectedcompanyplanproduct = products[products.length - 1]; //
                  for (let i = 0; i < products.length; i++) {
                    selectedCompanyplanProductsArray.push(
                      products[i]
                    );
                  }

                  /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                }
              }
              selectedCompanyplanProduct = selectedcompanyplanproduct;
              // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              //   selectedCompanyplanProductsArray.push(
              //     selectedCompanyplanProduct
              //   );
              // }
              //this.consoleMessage("CompanyTax")
              //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
              //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)
            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              console.log(selectedCCplanProductarray)
              console.log(selectedCompanyplanProduct)
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }


            }

            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }



            if (CCproductslength == 1) {
              modifiedCCplan = this.singleCCCoverageProduct(selectedCompanyplanProduct, selectedBaseplanProduct, selectedCCplanProduct, CCplan, upgradeText, payroll, selectedBasePlan, upgradepaymentText, modifiedCCplan)

            }
            else {
              modifiedCCplan = this.multipleCCCoverageProduct(selectedCCplanProductarray, selectedBaseplanProductsArray, selectedCompanyplanProductsArray, selectedBasePlan, CCplan, upgradeText, payroll, upgradepaymentText, selectedCoverage, modifiedCCplan)

            }
            modifiedCCgroup.plans.push(modifiedCCplan);
          }
          //           modifiedCCgroup.plans = Array.from(new Set(modifiedCCgroup.plans.map((item:any) => JSON.stringify(item)))
          // ).map((str:any) => JSON.parse(str));
          modifiedCCPackage.groupsCC.push(modifiedCCgroup);
        }

        modifiedCCplanPackages.push(modifiedCCPackage);
      }
      modifiedCCplanPackages = Array.from(new Set(modifiedCCplanPackages.map((item: any) => JSON.stringify(item)))
      ).map((str: any) => JSON.parse(str));
      this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages;

      console.log(this.modifiedBlocksCoveredByCompany)
    }
  }


    public DirectCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {

    //console.log("DirectCoveragemETHOD")
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

        //console.log(selectedCCplanProductarray[i])
        //console.log(selectedBaseplanProductsArray[j])

        if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        //console.log("ElseDirectCoveragemETHOD")
        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)

    //console.log(selectedBaseplanProductsArray2)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  
  public selectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;

    //console.log(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        //console.log(selectedBaseplanProductsArray[j])
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)

    //console.log(selectedBaseplanProductsArray2)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  

  public selectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

    public CompanyDirectCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {

    //console.log("DirectCoveragemETHOD")
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;



    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

    public CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

    public CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }


   public CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }


  public singleCCCoverageProduct(selectedCompanyplanProduct: any, selectedBaseplanProduct: any, selectedCCplanProduct: any, CCplan: any, upgradeText: any, payroll: any, selectedBasePlan: any, upgradepaymentText: any, modifiedCCplan: any) {
    let companyTax =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let companyTaxPercentage =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;
    let baseplanPrice = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.price
    );
    let baseplanTaxorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.tax
    );
    let baseplanTax = adjustWith2DecimalsForUI(
      baseplanPrice * companyTax
    );
    let baseplanTotalorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.total
    );
    let baseplanTotal = adjustWith2DecimalsForUI(
      baseplanPrice + baseplanTax
    );
    let employeeTax =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let employeeTaxPercentage =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;

    let deltaplanPrice = adjustWith2DecimalsForUI(
      selectedCCplanProduct.calculatedTax.price -
      selectedBaseplanProduct.calculatedTax.price
    );

    //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
    //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
    //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
    if (selectedBaseplanProduct.name == 'NA') {
      //this.consoleMessage("No Base plan/product for this upgrade plans/product")
      companyTax = employeeTax
      companyTaxPercentage = employeeTaxPercentage
    }
    let deltaplanTax = adjustWith2DecimalsForUI(
      deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
    );
    // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

    let deltaplanTotal = adjustWith2DecimalsForUI(
      deltaplanPrice + deltaplanTax
    );

    let combinedplanPrice = baseplanPrice + deltaplanPrice;
    let combinedplanbasePrice = baseplanPrice;
    let combinedplanDeltaprice = deltaplanPrice;
    let combinedplanTax = adjustWith2DecimalsForUI(
      baseplanTax + deltaplanTax
    );
    let combinedplanCompanyTax = baseplanTax;
    let combinedplanEmployeeTax =
      adjustWith2DecimalsForUI(deltaplanTax);
    let combinedplanCompanyTaxPercentage = companyTaxPercentage;
    let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
      ? companyTaxPercentage
      : employeeTaxPercentage;
    let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
    let combinedplanTotal = adjustWith2DecimalsForUI(
      baseplanTotal + deltaplanTotal
    );

    let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
    let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
    let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`;
    let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
    let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
    let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
    let type;

    if (payroll) {
      type = "Split with payroll deduction";
    } else {
      type = "Split with direct pay";
    }
    let basePlanDetails = {
      planId: selectedBasePlan.id || 0, //0
      planName: selectedBasePlan.name || "NA", //NA
      planLevelId: selectedBasePlan.planLevel || 0, //0
      amount: baseplanPrice || 0, //0
      amountUI: `$${baseplanPrice}` || 0, //0
      tax: baseplanTax,
      total: baseplanTotal,
      taxUI: `$${baseplanTax}`, //companyTaxpercentage
      totalUI: `$${baseplanTotal}`,
      planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
      planFrequencyID: selectedBasePlan.frqMonthly || "",
      planFusebillID: selectedBasePlan.fusebillId || "",
      products: [selectedBaseplanProduct],
      planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
      packageName: selectedBasePlan.packageName || "",
      packageId: selectedBasePlan.packageId || 0,
    };
    let obj = {
      companyTax,
      companyTaxPercentage,
      baseplanPrice,
      baseplanTaxorg,
      baseplanTax,
      baseplanTotalorg,
      baseplanTotal,
      employeeTax,
      employeeTaxPercentage,
      deltaplanPrice,
      deltaplanTax,
      deltaplanTotal,
      combinedplanPrice,
      combinedplanbasePrice,
      combinedplanDeltaprice,
      combinedplanTax,
      combinedplanCompanyTax,
      combinedplanEmployeeTax,
      combinedplanCompanyTaxPercentage,
      combinedplanemployeeTaxPercentage,
      combinedplanTotal,
      payroll,
      scenario,
      planName,
      compnayShareStatement,
      employeeShareStatement,
      planDescription,
      planDescription2,
      type,
      basePlanDetails,
      combinedplanemployeeTaxPercentageorg,
    };

    console.log(obj)
    modifiedCCplan.upgradeCalculation = obj;
    return modifiedCCplan
  }

  public multipleCCCoverageProduct(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCompanyplanProductsArray: any, selectedBasePlan: any, CCplan: any, upgradeText: any, payroll: any, upgradepaymentText: any, selectedCoverage: any, modifiedCCplan: any) {

    console.log(selectedCCplanProductarray)
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
      console.log(selectedBaseplanProduct)
      let selectedCompanyplanProduct =
        selectedCompanyplanProductsArray[i];
      let selectedCCplanProduct = selectedCCplanProductarray[i];
      console.log(selectedCCplanProduct)
      console.log(selectedCompanyplanProductsArray[i])
      let companyTax =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let companyTaxPercentage =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;

      let baseplanPrice = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.price
      );
      let baseplanTaxorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.tax
      );
      let baseplanTax = adjustWith2DecimalsForUI(
        baseplanPrice * companyTax
      );
      let baseplanTotalorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.total
      );
      let baseplanTotal = adjustWith2DecimalsForUI(
        baseplanPrice + baseplanTax
      );


      let employeeTax =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let employeeTaxPercentage =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;
      let deltaplanPrice = adjustWith2DecimalsForUI(
        selectedCCplanProduct.calculatedTax.price -
        selectedBaseplanProduct.calculatedTax.price
      );
      //console.log(deltaplanPrice)


      //console.log(selectedBaseplanProduct.calculatedTax.price)

      if (selectedBaseplanProduct.name == 'NA') {
        //this.consoleMessage("No Base plan/product for this upgrade plans/product")
        // companyTax = employeeTax
        companyTax = 0  ////when there is no base planproduct
        // companyTaxPercentage = employeeTaxPercentage
        companyTaxPercentage = "0%" //when there is no base planproduct

      }
      //Delete plan Total Price and Total Combination
      if (deltaplanPrice < 0) {
        deltaplanPrice = 0
        baseplanPrice = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.price
        );
        baseplanTaxorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.tax
        );
        baseplanTax = adjustWith2DecimalsForUI(
          baseplanPrice * companyTax
        );
        baseplanTotalorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.total
        );
        baseplanTotal = adjustWith2DecimalsForUI(
          baseplanPrice + baseplanTax
        );
      }
      // let deltaplanTax = adjustWith2DecimalsForUI(
      //   deltaplanPrice *
      //   (this.deltaCompanyTax ? companyTax : employeeTax)
      // );
      let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

      let deltaplanTotal = adjustWith2DecimalsForUI(
        deltaplanPrice + deltaplanTax
      );
      let combinedplanPrice = adjustWith2DecimalsForUI(
        baseplanPrice + deltaplanPrice
      );
      let combinedplanbasePrice = baseplanPrice;
      let combinedplanDeltaprice = deltaplanPrice;
      let combinedplanTax = adjustWith2DecimalsForUI(
        baseplanTax + deltaplanTax
      );
      let combinedplanCompanyTax = baseplanTax;
      let combinedplanEmployeeTax =
        adjustWith2DecimalsForUI(deltaplanTax);
      let combinedplanCompanyTaxPercentage = companyTaxPercentage;
      let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
        ? companyTaxPercentage
        : employeeTaxPercentage;
      let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

      let combinedplanTotal = adjustWith2DecimalsForUI(
        baseplanTotal + deltaplanTotal
      );

      let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
      let planName = `${CCplan.name} (${upgradeText})`;
      let compnayShareStatement = `${CCplan.name} Contribution`;
      let employeeShareStatement = `${CCplan.name} upgrade cost`;
      let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
      let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
      let type;

      if (payroll) {
        type = "Split with payroll deduction";
      } else {
        type = "Split with direct pay";
      }
      let basePlanDetails = {
        planId: selectedBasePlan.id, //0
        planName: selectedBasePlan.name, //NA
        planLevelId: selectedBasePlan.planLevel, //0
        amount: baseplanPrice, //0
        amountUI: `$${baseplanPrice}`, //0
        tax: baseplanTax,
        total: baseplanTotal,
        taxUI: `$${baseplanTax}`, //companyTaxpercentage
        totalUI: `$${baseplanTotal}`,
        planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
        planFrequencyID: selectedBasePlan.frqMonthly || "",
        planFusebillID: selectedBasePlan.fusebillId || "",
        products: [selectedBaseplanProduct],
        planLevel_parentId: selectedBasePlan.planLevel_parentId,
        packageName: selectedBasePlan.packageName,
        packageId: selectedBasePlan.packageId,
      };





      let obj = {
        companyTax,
        companyTaxPercentage,
        baseplanPrice,
        baseplanTaxorg,
        baseplanTax,
        baseplanTotalorg,
        baseplanTotal,
        employeeTax,
        employeeTaxPercentage,
        deltaplanPrice,
        deltaplanTax,
        deltaplanTotal,
        combinedplanPrice,
        combinedplanbasePrice,
        combinedplanDeltaprice,
        combinedplanTax,
        combinedplanCompanyTax,
        combinedplanEmployeeTax,
        combinedplanCompanyTaxPercentage,
        combinedplanemployeeTaxPercentage,
        combinedplanTotal,
        payroll,
        scenario,
        planName,
        compnayShareStatement,
        employeeShareStatement,
        planDescription,
        planDescription2,
        type,
        basePlanDetails,
        combinedplanemployeeTaxPercentageorg,
        selectedCoverage
      };

      //this.consoleMessage(obj)

      console.log(obj)

      if (modifiedCCplan.products) {

      } else {
        modifiedCCplan.products = []
      }
      let ccProduct: any = {}
      ccProduct.upgradeCalculation = obj;
      modifiedCCplan.products.push(ccProduct)
      modifiedCCplan.upgradeCalculation = obj;

      //console.log(modifiedCCplan)
    }

    return modifiedCCplan
  }


    public customerSelectedPlansValues(selectedPlans) {

    let data: any = selectedPlans;
    let obj = {};

    if (data) {

      data.forEach((element: any, index: any) => {
        obj = {
          planid: element.id,
        };

        setTimeout(() => {

          const dom: HTMLElement = this.elementRef.nativeElement;


          if (element.options && element.options.length > 0) {

            if (element.isBundle) {
              // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);


              // this.renderer.setProperty(planCheck, 'checked', true);
              const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());
              // this.renderer.setProperty(plan, 'checked', true);
              if (plan) {
                plan.click(); // Simulate a user click
              }


            } else {
              // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);


              // this.renderer.setProperty(planCheck, 'checked', true);
              if (element.coverage1) {
                const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());


                // this.renderer.setProperty(plan, 'checked', true);
                if (plan) {
                  plan.click(); // Simulate a user click
                }
              }
              else {
                const planCheck = this.renderer.selectRootElement("#plancheck" + element.planSelectionId2, true);
                // this.renderer.setProperty(planCheck, 'checked', true);
                if (planCheck) {
                  planCheck.click(); // Simulate a user click
                }

              }



            }

          }

          else {

            if (element.isBundle) {
              const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());

              let CoverageSelection;
              // this.renderer.setProperty(plan, 'checked', true);
              if (plan) {
                plan.click(); // Simulate a user click
              }


              // const planCheck = this.renderer.selectRootElement("#plancheck" + element.id, true);

              // // //console.log(planCheck)
              // this.renderer.setProperty(planCheck, 'checked', true);









            }
            else {
              // element.products.forEach((products: any, index: any) => {
              // $("#plancheck" + products.id).click();
              // const planCheck = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
              //   //console.log(planCheck)
              // this.renderer.setProperty(planCheck, 'checked', true);
              if (element.coverage1 && element.coverage1.length > 2) {
                const plan: any = dom.querySelector("#plancheck" + element.planSelectionId2 + ".coverage" + element.coverage1.toUpperCase());


                // this.renderer.setProperty(plan, 'checked', true);
                if (plan) {
                  plan.click(); // Simulate a user click
                }
              }
              else {
                const planCheck = this.renderer.selectRootElement("#plancheck" + element.planSelectionId2, true);
                if (planCheck) {
                  this.renderer.setProperty(planCheck, 'checked', true);
                  planCheck.dispatchEvent(new Event('change')); // Notify Angular of the change
                }

              }
              // if (element.paidByCompany == 1) {
              //   const dom: HTMLElement = this.elementRef.nativeElement;
              //   if (element.coverage) {
              //     const plan: any = dom.querySelector("#plancheck" + products.planLevel + ".coverage" + element.coverage);
              //     if (plan) {
              //       plan.disabled = true;
              //     }
              //   }
              //   else {
              //     const plan = this.renderer.selectRootElement("#plancheck" + products.planLevel, true);
              //     if (plan) {
              //       plan.disabled = true;
              //     }
              //   }
              // }
              // })


            }
          }

          // $("#plancheck" + element.id).prop("checked", true);
          // plan.checked =true
        }, 100);

        // this.plancheckarray.push(element.id)
      });

    }

  }



    public convertpackagesToPlans2(packages: { paidByCompany: any[]; }) {
    //this.consoleMessage("pacakges");
    //all_plans
    var plans: any[] = [];
    var cp_plans: any[] = [];
    var cc_plans: any[] = [];
    var ep_plans: any[] = [];

    packages?.paidByCompany.forEach((pack: { groupsCP: any[]; name: any; }, index: any) => {
      pack.groupsCP.forEach((group: { plans: any[]; parentId: any; name: any; id: any; categorization: { paidByCompany: any; coveredByCompany: any; paidByEmployee: any; companyPaidCoverage: any }; }, index1: any) => {
        group.plans.forEach((plan: { [x: string]: any; }, index2: any) => {
          if (plan) {
            const coverages = ['SINGLE', 'COUPLE', 'FAMILY'];
            
            plan["planLevel_parentId"] = group.parentId;
            plan["packageName"] = pack.name;
            plan["groupName"] = group.name;
            plan["groupId"] = group.id;
            plan["groupparentId"] = group.parentId;
            plan["companyPaidCoverage"] = group.categorization?.companyPaidCoverage ?? "DIRECT";
            plans.push(plan);

            if (group.categorization.paidByCompany) {
              cp_plans.push(plan);
            }
            if (group.categorization.coveredByCompany) {
              cc_plans.push(plan);
            }
            if (group.categorization.paidByEmployee) {
              ep_plans.push(plan);
            }
          } else {
            //this.consoleMessage("else");
          }
        });
      });
    });



    return [plans, cp_plans, cc_plans, ep_plans];
  }

    calculateBasePlanCPplans(cpplanspackages: string | any[], baseplansMain: any[], compnayplans: any[]) {

    console.log(cpplanspackages)
    console.log(baseplansMain)

    if (baseplansMain) {
      baseplansMain = baseplansMain.filter(name => name.productAddonssNames.length > 0)
    }



    let selectedbasePlanMain;
    console.log(baseplansMain)
    let modifiedCPplanPackages: any = [];
    for (let i = 0; i < cpplanspackages?.length; i++) {
      if (baseplansMain) {
        selectedbasePlanMain = baseplansMain.filter(name => name.packageId == cpplanspackages[i].id)
        if (selectedbasePlanMain.length > 0) {
          selectedbasePlanMain = selectedbasePlanMain[selectedbasePlanMain.length - 1]
        }

      }
      let modifiedCPPackage = cpplanspackages[i];

      let CPplansgroups = cpplanspackages[i].groupsCP;

      modifiedCPPackage.groupsCP = [];
      for (let CPplangroup of CPplansgroups) {
        let modifiedCPgroup = CPplangroup;
        let selectedCoverage = CPplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"
        if (selectedCoverage == "null") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        console.log(selectedCoverage)


        if (selectedCoverage == "DIRECT") {
          modifiedCPPackage.groupsCP.push(modifiedCPgroup)
          if (modifiedCPPackage.groupsCP.length == CPplansgroups.length) {
            modifiedCPplanPackages.push(modifiedCPPackage)
          }
          continue;
        }
        let CPplans = CPplangroup.plans;

        //console.log(CPplangroup)

        modifiedCPgroup.plans = [];
        let baseplans:any = []
        for (let CPplan of CPplans) {
          let modifiedCPplan = CPplan;


          CPplan.planLevel_parentId = CPplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CPplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CPplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          console.log(CPplan)
            let selectedCPplanProductarray: any
          if (CPplan.isBundle == true) {
            selectedCPplanProductarray = CPplan.productAddonss[CPplan.name];
          } else {
            selectedCPplanProductarray = Object.keys(CPplan.productAddonss)
          }

          console.log(selectedCPplanProductarray)
          // let selectedCPplanProductarray: any = Object.keys(CPplan.productAddonss)


          /* this is filtering other products which are not to be displayed */
          selectedCPplanProductarray = selectedCPplanProductarray.filter((prop: any) => prop.display)


          // let selectedCPplanProductarray: any = Object.keys(CPplan.productAddonss)

          console.log(selectedCPplanProductarray)
          if (selectedbasePlanMain) {
            let selectedMainProductarray: any = selectedbasePlanMain.productAddonss[selectedbasePlanMain.name];

            console.log(selectedMainProductarray)
            //console.log(CPplan.productAddonss[CPplan.name])

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedMainProductarray.length; j++) {
                if (selectedMainProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedMainProductarray[i])
                }

              }
            }
          }
          else {
            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedCPplanProductarray.length; j++) {
                if (selectedCPplanProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedCPplanProductarray[i])
                }

              }

            }

          }






          if (CPplan.isBundle) {

            console.log(baseplans)
            var filtered_base_plans = baseplans



            //this.consoleMessage(filtered_base_plans);

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan:any;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray:any = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];

            //console.log("length" + filtered_base_plans.length)

            selectedBasePlan = filtered_base_plans[0];

            console.log(selectedBasePlan)

            if (selectedBasePlan) {
              // //this.consoleMessage(selectedBasePlan)
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = [selectedBasePlan];
              let selectedBaseplanProductsArray2 = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CPplan.packageId == 5 || CPplan.packageId == 10) {

                // selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                // for (let i = 0; i < selectedCPplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                // }
                // // //this.consoleMessage(selectedBaseplanProductsArray)
                // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                // Direct Coverage Method

                // selectedBaseplanProductsArray =this.DirectCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)


                // Selective single Coverage Method

                //  selectedBaseplanProductsArray =this.selectiveSingleCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)

                // Selective Couple Coverage Method
                if (selectedCoverage != "DIRECT") {
                  selectedBaseplanProductsArray = this.selectiveCPCoverageMethod(selectedCPplanProductarray, selectedBaseplanProductsArray, selectedCoverage)
                }
                //  // Selective Family Coverage Method


              }
            }
            else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCPplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }



            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCPplan.products = []

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              console.log(selectedBaseplanProduct)
              let selectedCPplanProduct = selectedCPplanProductarray[i];
              console.log(selectedCPplanProduct)
              let coverage = selectedCPplanProduct.planCoverage

              console.log(coverage)
              if (selectedCoverage == coverage) {

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;
              }

              console.log(selectedCPplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];

              let companyTax;
              let companyTaxPercentage;
              let employeeTax;
              let employeeTaxPercentage;

              if (selectedBaseplanProduct) {
                companyTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              }
              else {
                companyTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              }




              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );



              console.log(selectedCPplanProduct)

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCPplanProduct?.calculatedTax?.price -
                selectedBaseplanProduct?.calculatedTax?.price
              );
              console.log(deltaplanPrice)


              //console.log(selectedBaseplanProduct.calculatedTax.price)

              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice <= 0) {
                deltaplanPrice = 0
                /*      baseplanPrice = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.price
                    );
                     baseplanTaxorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.tax
                    );
                     baseplanTax = adjustWith2DecimalsForUI(
                      baseplanPrice * companyTax
                    );
                     baseplanTotalorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.total
                    );
                     baseplanTotal = adjustWith2DecimalsForUI(
                      baseplanPrice + baseplanTax
                    ); */

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;

              }


              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice *
              //   (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name}  (${selectedCoverage}) to ${CPplan.name}`;
              let planName = `${CPplan.name} (${this.capitalize(coverage)}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name} (${this.capitalize(selectedCoverage)})  Contribution`;
              let employeeShareStatement = `${CPplan.name} (${this.capitalize(coverage)}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage,
                selectedCoverage
              };

              //this.consoleMessage(obj)

              //console.log(selectedCoverage)
              //console.log(coverage)

              //console.log(obj)
              let cpProduct: any = {}
              cpProduct.upgradeCalculation = obj;
              modifiedCPplan.products.push(cpProduct)
              // modifiedCPplan.upgradeCalculation = obj;

              // if(selectedCoverage == coverage){

              // }else{
              //   cpProduct.upgradeCalculation = obj;
              //   modifiedCPplan.products.push(cpProduct)
              // }

              //console.log(modifiedCPplan)
            }

          }
          else {
            //this.consoleMessage("Not a BundlePlan")

            //this.consoleMessage(baseplans)



            filtered_base_plans = baseplans

            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            //console.log("length" + filtered_base_plans.length)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 0) {
              selectedBasePlan = filtered_base_plans[0];
            } else {
              //this.consoleMessage(filtered_base_plans.length)
            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;

            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                //this.consoleMessage(planname)
                //this.consoleMessage(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                //console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  //this.consoleMessage(products.length)
                }
              }
              //this.consoleMessage(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";
            }

            let CCplanProduct;

            for (let planname in CPplan.productAddonss) {
              let products = CPplan.productAddonss[planname];
              //console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
                // selectedCompnayPlan= filtered_compnay_plans[0]
              } else {
                //this.consoleMessage(products.length)
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;

            if (selectedCompnayPlan) {

              let upgradeText;
              let upgradepaymentText;
              if (payroll) {
                upgradeText = "Employee upgraded using payroll deduction";
                upgradepaymentText = "using payroll deduction";
                //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
              } else {
                upgradeText = "Employee upgraded using Direct payment";
                upgradepaymentText = "using Direct payment";
              }
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );
              let coverage = selectedCCplanProduct.planCoverage
              let employeeTax =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );

              //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );

              let combinedplanPrice = baseplanPrice + deltaplanPrice;
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
              let planName = `${CPplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) Contribution`;
              let employeeShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id || 0, //0
                planName: selectedBasePlan.name || "NA", //NA
                planLevelId: selectedBasePlan.planLevel || 0, //0
                amount: baseplanPrice || 0, //0
                amountUI: `$${baseplanPrice}` || 0, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
                packageName: selectedBasePlan.packageName || "",
                packageId: selectedBasePlan.packageId || 0,
              };
              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage
              };

              //this.consoleMessage(obj)
              // modifiedCPplan.upgradeCalculation = obj;
            }
          }
          modifiedCPgroup.plans.push(modifiedCPplan);

          modifiedCPPackage.groupsCP.push(modifiedCPgroup);
        }
        //console.log(modifiedCPPackage)
        modifiedCPplanPackages.push(modifiedCPPackage);
      }

      this.modifiedBlocksPaidByCompany = modifiedCPplanPackages;

      console.log(this.modifiedBlocksPaidByCompany)

      //this.consoleMessage(this.modifiedBlocksCoveredByCompany)
    }
  }


    public selectiveCPCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCoverage: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2: any = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == selectedCoverage })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }


    public capitalize(str: String) {
    if (str) {
      // return str.charAt(0).toUpperCase() + str.slice(1);
      const words = str.split(' ');

      let finalres: any = words.filter((v) => v != '');
      return finalres
        .map((word: any) => {
          return word[0].toUpperCase() + word.substring(1);
        })
        .join(' ');
    }
  }
  
    cobminedcommonfunction(cpPackages: any, ccPackages: any, epPackages: any) {

    // //console.log(cpPackages)
    let commonPackages: any = {};
    if (cpPackages) {
      for (let cpPackage of cpPackages) {
        let pckg = cpPackage;
        pckg.groups = pckg.groupsCP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups.push(pckg.groupsCP);
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    //this.consoleMessage(commonPackages)
    if (ccPackages) {
      for (let ccPackage of ccPackages) {
        let pckg = ccPackage;
        //this.consoleMessage(pckg)
        pckg.groups = pckg.groupsCC;

        //this.consoleMessage(pckg.groups)
        //this.consoleMessage(pckg.groupsCC)

        if (commonPackages && commonPackages[pckg.id]) {
          //this.consoleMessage(commonPackages[pckg.id])
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsCC
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    if (epPackages) {
      for (let epPackage of epPackages) {
        let pckg = epPackage;
        pckg.groups = pckg.groupsEP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsEP
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }

    return commonPackages;


  }



  showRequestHistory(queue:any){
    const history = JSON.parse(queue.notificationHistory);
    this.reasonList_(queue.data.data.reason)
    this.notificationHistory = history;
  }



  updateChildDetails_v2(child, index) {
    this.showChildForm = true;
    if (child.coveredByAnotherPlan == true) {
      this.dependentChildCoverage = 'open';
      this.childCoverage = true;
    }
    this.childIndex = index;
    console.log(child)
    this.pureDependentform.patchValue({
      firstName: child.firstName,
      lastName: child.lastName,
      dob: moment(child.dob).format('MM-DD-YYYY'),
      coveredByAnotherPlan: child.coveredByAnotherPlan,
      carrierName: child.carrierName,
      specialNeeds: child.specialNeeds,
      postSecondaryStudent: child.postSecondaryStudent ? child.postSecondaryStudent : false,
      graduationDate: child.graduationDate && moment(child.graduationDate).format('MM-DD-YYYY'),
      // gender: child.gender,
    })
  }


  closeHandleChildDetails() {
    this.showChildForm = false;
     this.dependentChildCoverage = 'close'
    this.pureDependentform.reset();
  }

  handleChildDetails_v2() {
    console.log(this.pureDependentform)
   

    if (this.pureDependentform.valid) {
      console.log("accessed", this.pureDependentform.valid, this.pureDependentform)
      this.showChildForm = false;
      const updatedData = this.dependentDetails.map((item, index) => {
        if (index === this.childIndex) {
          return this.pureDependentform.value // Replace with new value
        }
        return item; // Return the original object for all other indices
      });
      this.dependentDetails = updatedData;
      let childrenName = this.pureDependentform.value.firstName + ' ' + this.pureDependentform.value.lastName;
      let effectiveDate = moment(this.pureDependentform.value.effectiveDate).format('DD-MM-YYYY')
      // if (this.pureDependentform.value.specialNeeds) {
      //   Swal.fire({ title: 'Info', text: `Your child ${childrenName} has Special needs, and needs be processed before ${effectiveDate} can be covered. Please check with you advisor on the status of enrollment.` })
      // } else {
      //   Swal.fire({ title: 'Info', text: 'Child info has been updated successfully.' })
      // }
      this.pureDependentform.reset();
    } else {
      this.pureDependentform.markAllAsTouched();
      return;
    }

    this.dependentChildCoverage = 'close'
    this.pureDependentform.reset();
  }

  checkFirstCharacter(event: any, form: any) {
    //this._LoggerService.log(event)
    if (event.target.value.startsWith(' ')) {
      event.target.value = event.target.value.trimStart();
    }
    //this._LoggerService.log(form)
    //this._LoggerService.log(event.target.id)
    //this._LoggerService.log(this.addressform.get('line1')?.value)
    //this._LoggerService.log(form.get(event.target.id));
    // Removing the special characters
    // form.get(event.target.id).setValue(event.target.value.replace(/[^a-zA-Z0-9\s]/g, ''));
  }
  
  deleteChildDetails_v2(index) {
    this.dependentDetails.splice(index, 1)
  }

  handleShowRequestDetails3(queue: any) {
    console.log(queue)
    this.body = ""
    this.toEmail = ""
    this.ccList = ""
    this.subject = ""

    let endPoint = `/admin/customer/${queue.customerId}/details/first`

    this.http.get(environment.apiUrl + '/api/ap' + endPoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe(async (response: any) => {
      if (response.statusCode == 200) {

        this.ccList += response.data.primaryEmail ?? "";

      } else {
        Swal.fire({ allowOutsideClick: false, title: "Error", text: response.message });
      }
    },
      (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: "Info",
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: "Proceed",
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: "Error", text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      })

    this.subject = queue.process
    this.roeFile = queue?.ROE?.data?.roe ?? "";
    const url = queue?.ROE?.data?.roe;
    this.fileName = url.split('/').pop();
    this.requestQueueData = queue;
    this.spouseDetails = queue.data.spouseDetails;
    this.dependentDetails = queue.data.childrenDetails;
    this.isSpouse = Object.keys(queue.data.spouseDetails).length > 0 ? true : false;
    this.isDependent = queue.data.childrenDetails.length > 0 ? true : false;
    this.plansSummaryObj = queue.data.plans;
    let existingBody = sessionStorage.getItem("mailBody");
    console.log(existingBody)
    if(existingBody){
      this.body = existingBody
    }else{
      this.body = mailSuggestedTextForProviders(queue.serviceType, queue.data.eventType2, queue.data.effectiveDate)
      this.body += "\n"
      this.body += "\n"
      this.body += `${getServiceType(queue.serviceType)} Id: ${queue.serviceType.greenShildCustomer ? queue.customer.greenshieldMemberId : queue.serviceType.equitableCustomer ? queue.customer.equitableCertificateId : 'NA' }\n`;
      this.body += `Dependent Details \n`
      this.body += '------------------ \n'
      this.body += `Type: ${this.isSpouse ? "Spouse" : "Child"} \n`
      if (this.isSpouse) {
        this.body += `First Name: ${this.spouseDetails.firstName} \n`
        this.body += `Last Name: ${this.spouseDetails.lastName} \n`
        this.body += `Dob: ${this.handleProcessDate(this.spouseDetails.dob)} \n`
        this.body += `Gender: ${this.spouseDetails.gender} \n`
        this.body += `Covered By Another Plan: ${this.spouseDetails.coveredByAnotherPlan ? "Yes" : "No"} \n`
        if (this.spouseDetails.coveredByAnotherPlan) {
          this.body += `Carrier Name: ${this.spouseDetails.insurer} \n`
          this.body += `Health Plan: ${this?.spouseDetails?.healthPlan ?? 'SINGLE'} \n`
        }
        
      }else{
        for (const dep of this.dependentDetails) {
          this.body += `First Name: ${dep.firstName} \n`
          this.body += `Last Name: ${dep.lastName} \n`
          this.body += `Dob: ${this.handleProcessDate(dep.dob)} \n`
          this.body += `Gender: ${dep?.gender ?? "Undisclosed"} \n`
          this.body += `Graduation Date: ${dep.graduationDate} \n`
          this.body += `Covered By Another Plan: ${dep.coveredByAnotherPlan ? "Yes" : "No"} \n`
          if (dep.coveredByAnotherPlan) {
            this.body += `Carrier Name: ${dep.carrierName} \n`
          }
  
        }
      }

      this.body += '\n'
  
      this.body += getFooterTextForEmail()
    }
  

    // this.notificationHistory = [{"text": "dependent added from member portal by member", "date": "18-03-25"}, {"text": "admin sent mail to greenshield", "date": "18-03-25"}, {"text": "greenshield approved the request with effective date from 01-03-25", "date": "19-03-25"}]
  }

   deleteRoeFile() {
    this.fileName = "";
    this.roeFile = ""
  }

  handleShowRequestDetails4(queue: any) {
    console.log(queue)
    this.requestQueueData = queue;
    this.spouseDetails = queue.data.spouse;
    this.dependentDetails = queue.data.dependent;
    
    this.isSpouse = Object.keys(queue.data.spouse).length > 0 ? true : false;
    this.isDependent = queue.data.dependent.length > 0 ? true : false;
    if(this.isDependent){
      const updatedChildren = this.dependentDetails.map(child => ({
        ...child,
        gender: 'Male' // add new property
      }));

      this.dependentDetails = updatedChildren
    }
    this.plansSummaryObj = queue.data.data.plans;
    // this.notificationHistory = [{"text": "dependent added from member portal by member", "date": "18-03-25"}, {"text": "admin sent mail to greenshield", "date": "18-03-25"}, {"text": "greenshield approved the request with effective date from 01-03-25", "date": "19-03-25"}]
  }

  getParsedSubText(subText){
    return subText.replace(/\n/g, '<br>')
  }

  sendEmail() {
    console.log(this.requestQueueData)
    // return;
    let service = this.requestQueueData.customer.equitableCertificateId != "" ? "Equitable" : "Greenshield"
    // Validate inputs
    if (!this.toEmail || !this.subject || !this.body) {
      alert('Please fill in all required fields.');
      return;
    }

    // Prepare CC list (split by comma and trim whitespace)
    const ccEmails = this.ccList.split(',').map(email => email.trim());

    // Prepare email payload
    const emailPayload = {
      toList: this.toEmail,
      subject: this.subject,
      body: this.body,
      ccList: ccEmails,
      roeFile: this.roeFile,
      roeFileName: this.fileName,
      serviceProvider: getServiceType(this.requestQueueData.serviceType)
    };

    // Call your email service or API here
    console.log('Sending email with payload:', emailPayload);

    // call the api

    let endPoint = `/api/ap/send-mail-from-queue/${this.requestQueueData.id}`
    let inputData = emailPayload
    this.http.post(environment.apiUrl + endPoint, inputData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.statusCode == 200) {
        console.log("mail sent");
        Swal.fire({
          title: "Info",
          text: "Mail sent successfully",
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        }).then((result) => {
          window.location.reload();
        })
      } else {
        Swal.fire({ allowOutsideClick: false, title: "Error", text: response.message });
      }
    },
      (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: "Info",
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: "Proceed",
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: "Error", text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      })

    // Reset form after sending
    this.resetEmailForm();
  }

  // Method to reset email form
  resetEmailForm() {
    this.toEmail = '';
    this.subject = '';
    this.body = '';
    this.ccList = '';
  }

  saveReminder() {
    // Validate inputs
    if (!this.reminderStatus || !this.reminderTime || !this.reminderText) {
      alert('Please fill in all required fields.');
      return;
    }

    // Prepare reminder payload
    const reminderPayload = {
      event: this.reminderStatus,
      reminderDate: moment(this.reminderTime).format('YYYY-MM-DD'),
      reminderText: this.reminderText,
    };

    let endPoint = `/api/ap/set-remainder/${this.requestQueueData.id}`
    let inputData = reminderPayload
    this.http.post(environment.apiUrl + endPoint, inputData, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.statusCode == 200) {
        console.log("mail sent");
        Swal.fire({
          title: "Info",
          text: "Reminder set successfully",
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: "Proceed",
        }).then((result) => {
          window.location.reload()
        })
      } else {
        Swal.fire({ allowOutsideClick: false, title: "Error", text: response.message });
      }
    },
      (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: "Info",
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: "Proceed",
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: "Error", text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      })

    // Call your reminder service or API here
    console.log('Saving reminder with payload:', reminderPayload);

    // Reset form after saving
    this.resetReminderForm();
  }

  // Method to reset reminder form
  resetReminderForm() {
    this.reminderStatus = 'Pending';
    this.snoozeTime = '';
    this.reminderTime = '';
    this.reminderText = '';
  }

  openDependentCoverage(value: any) {

    this.dependentCoverage = value;

    if (this.dependentCoverage === 'open') {
      this.childCoverage = true;
    }

  }

  handleCoverageChange(coverage: any) {
    switch (coverage) {
      case 'CTF':
        return "Couple to Family";
      case 'STC':
        return "Single to Couple";
      case 'STF':
        return "Single to Family";
      case 'FTS':
        return "Family to Single";
      case 'FTC':
        return "Family to Couple";
      default:
        return "Single to Couple";
    }
  }

  reasonList_(reason:any) {
    let resonList_:any = []
    for(const reaso of reason) {
      resonList_.push(reaso);
    }
    console.log(resonList_, "resonList_")
    this.reasonList =  resonList_.map(item => item.subText ?? "NA")
  }
}
